import { useEffect, useState, useRef, forwardRef } from "react";
import "./style.css";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SubHeader from "../../components/SubHeader";
import * as XLSX from "xlsx";
import CancelIcon from "@mui/icons-material/Cancel";
import swal from "sweetalert";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import moment from "moment";
import Snackbar from "@mui/material/Snackbar";
import { useNavigate } from "react-router-dom";
import _, { isNumber } from "lodash";
import {
  bookContract,
  statusContract,
  getTradesStateByUserName,
  deleteTradeState,
  updateTradeState,
  getOpenContractValueByCptyID,
  SaveTradeStateList,
  getContractBookingServiceHealthCheck,
  getTradeStateServiceHealthCheck,
} from "../../utils/API";
import RefreshIcon from "@mui/icons-material/Refresh";
import withRefresh from "../../redux/HOC/withRefresh";
import withUser from "../../redux/HOC/withUser";
import withCpty from "../../redux/HOC/withCpty";
import withTicker from "../../redux/HOC/withTicker";
import { Modal, Button } from "react-bootstrap";
import { Column } from "ag-grid-community";
import SpinnerFullScreen from "../../components/SpinnerFullScreen";
import useWindowDimensions from "../../utils/window-dimentions";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { messages, constants, socketMsgType } from "../../common/constants";
import { isString } from "lodash";
import { validateRate, validateTermDate } from "../../common/tradeValidations";
import { calculateContractPriceFromValues, hasAccess, mapRowId } from "../../common/commonFunctions";
import ContractGrid from "./Grid";
import { pageConstant } from "../../config/pageConstant";
import excel from "../../assets/images/excel.svg";
import SockJS from "sockjs-client";
import { BASE_URI_SOCKET, envs, getEnv } from "../../config/service-api-mapping";
import { Stomp } from "@stomp/stompjs";
import Queue from 'yocto-queue';

const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Contract = ({
  setRefresh,
  refresh,
  user,
  set_CptyData,
  tickerSet,
}: any) => {
  const [rowData, setRowData] = useState<any>([]);
  const [heightAG_1] = useState(35);
  const [excelFileName, setExcelFileName] = useState("");
  const [workbookData, setworkbookData] = useState<any>(null);
  const [refData, setRefData] = useState<any>(null);
  const [tradeType, setTradeType] = useState("");
  const [borrowAndLoanFieldLength, setBorrowAndLoanFieldLength] = useState("");
  const [counterPartyinConttract, setCounterPartyinContract] = useState("");
  const [tickerContract, setTickerContract] = useState("");
  const [quantityContract, setQuantityContract] = useState<any>("");
  const [rateFieldContract, setRateFieldContract] = useState<any>("");
  const [markFieldContract, setMarkFieldContract] = useState<any>("");
  const [markAllValue, setMarkAllValue] = useState<any>("");
  const [markField, setMarkField] = useState<any>("");
  const [markFieldEvent, setMarkFieldEvent] = useState<any>("");
  const [markFieldisMatch, setMarkFieldisMatch] = useState<any>("");
  const [markFieldisMatchEvent, setMarkFieldisMatchEvent] = useState<any>("");
  const [tickerPrice, setTickerPrice] = useState<any>("");
  const [tickerCusip, setTickerCusip] = useState<any>("");
  const [contractValueContract, setContractValueContract] = useState("");
  const [contractValueEventContract, setContractValueEventContract] =
    useState("");
  const [contractPriceContract, setContractPriceContract] = useState("");
  const [contractPriceContractisMatch, setContractPriceContractisMatch] =
    useState("");
  const [profitCenterFieldContract, setProfitCenterFieldContract] =
    useState("");
  const [divTextFieldContract, setDivTextFieldContract] = useState("");
  const [termDateFieldContract, setTermDateFieldContract] = useState("");
  const [cashNonCashContract, setCashNonCashContract] = useState<any>("");
  const [baLinConttractisMatch, setBaLinContractisMatch] = useState("");
  const [counterPartyinConttractisMatch, setCounterPartyinContractisMatch] =
    useState("");
  const [tickerContractisMatch, setTickerContractisMatch] = useState("");
  const [quantityContractisMatch, setQuantityContractisMatch] = useState("");
  const [rateFieldContractisMatch, setRateFieldContractisMatch] =
    useState<any>("");
  const [markFieldContractisMatch, setMarkFieldContractisMatch] =
    useState<any>("");
  const [contractValueContractisMatch, setContractValueContractisMatch] =
    useState("");
  const [
    contractValueContractEventisMatch,
    setContractValueContractEventisMatch,
  ] = useState("");
  const [
    profitCenterFieldContractisMatch,
    setProfitCenterFieldContractisMatch,
  ] = useState<any>("");
  const [divTextFieldContractisMatch, setDivTextFieldContractisMatch] =
    useState<any>("");
  const [cashNonCashMatchContract, setCashNonCashMatchContract] = useState("");
  const [counterPartySearch, setCounterPartySearch] = useState("");
  const [tickerSearch, setTickerSearch] = useState("");
  const [counterPartySearchisMatch, setCounterPartySearchisMatch] =
    useState("");
  const [tickerSearchisMatch, setTickerSearchisMatch] = useState("");
  const [checkedRadioContract, setCheckRadioContract] = useState(false);
  const [minimizeTrade, setMinimizeTrade] = useState(true);
  const [minimizeContract, setMinimizeContract] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowsBookContract, setSelectedRowsBookContract] = useState<any>(
    []
  );
  const [totalSelectedRows, seTtotalSelectedRows] = useState<any>([]);
  const [needToClearForm, setNeedToClearForm] = useState(false);
  const [bookContractStatusResponse, setBookContractStatusResponse] =
    useState<any>([]);

  const [isSubmitDisabledToggle, setIsSubmitDisabledToggle] =
    useState<boolean>(false);
  const [datalengthstate, setDatalengthstate] = useState<any>([]);
  const [excelDataPopOpen, setExcelDataPopOpen] = useState<any>(false);
  const [excelDataBookPopOpen, setExcelDataBookPopOpen] = useState<any>(false);
  const [excelDataClearPopOpen, setExcelDataClearPopOpen] =
    useState<any>(false);
  const [open, setOpen] = useState(false);
  const [cptyListContract, setCptyListContract] = useState<any>("");
  const [tickerListContract, setTickerListContract] = useState<any>("");
  const [snackbarMessage, setSnackbarMessage] = useState<any>("");

  const [disableClearBtn, setDisableClearBtn] = useState(false);
  const [showClearLoader, setShowClearLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [gridLoder, setGridLoder] = useState(false);
  const [borrowValOpen, setBorrowValOpen] = useState(false);
  const [showInvalidFilePopUp, setShowInvalidFilePopUp] = useState(false);
  const [invalidFileEntries, setInvalidFileEntries] = useState("");
  const [submitheader, setSubmitheader] = useState(false);
  const [loanValOpen, setLoanValOpen] = useState(false);
  const [borrowValVal, setBorrowValVal] = useState("");
  const [thisContractVal, setThisContractVal] = useState("");
  const [loanValVal, setLoanValVal] = useState("");
  const [borrAcctLimit, setBorrAcctLimit] = useState("");
  const [borrCptyIdModal, setBorrCptyIdModal] = useState("");
  const [loanCptyIdModal, setLoanCptyIdModal] = useState("");
  const navigate = useNavigate();
  const [outstandingBorrow, setOutstandingBorrow] = useState("");
  const [loanAcctLimit, setLoanAcctLimit] = useState("");
  const [outstandingLoan, setOutstandingLoan] = useState("");
  // const [submitdie, setSubmitdie] = useState(false);
  const [excelLoder, setExcelLoder] = useState(false);
  //Status Flag that represents the ongoing process of bulk upload through excell
  const [isBulkUploadRunning, setIsBulkUploadRunning] = useState(false);
  //Status Flag that represents the ongoing process of bulk booking after clicking on submit button
  const [isBulkSubmitRunning, setIsBulkSubmitRunning] = useState(false);
  const [isInitialRefresh, setIsInitialRefresh] = useState(false);
  const [isTradeServiceDown, setIsTradeServiceDown] = useState(false);
  const [
    getCptyDataForBookContractBorrow,
    SetGetCptyDataForBookContractBorrow,
  ] = useState<any>([]);
  const [getCptyDataForBookContractLoan, SetGetCptyDataForBookContractLoan] =
    useState<any>([]);
  const [disabled, setDisabled] = useState(false);
  const [invalidQuantity, setInvalidQuantity] = useState(false);
  let isContractStatusEnabled = true;
  // Create our number formatter.
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });
  const [isDeselectAll, setIsDeselectAll] = useState(false);

  const [isNoRecordsSelectedWarning, setisNoRecordsSelectedWarning] =
    useState(false);

  const [cptyListContractMap, setCptyListContractMap] = useState<any>(null);
  const [tickerCusipMaster, setTickerCusipMaster] = useState<any>(null);
  const [tickerNameMaster, setTickerNameMaster] = useState<any>(null);
  const socketConsolidate = new SockJS(`${BASE_URI_SOCKET()}`);
  const socketConsolidateClient = Stomp.over(function () {
    return socketConsolidate;
  });
  const queue = new Queue();

  useEffect(() => {
      socketConsolidateClient.connect(
        {},
        function (frame: any) {
          socketConsolidateClient.subscribe(
            "/topic/consolidated_message",
            function (result: any) {
              let resultJson = JSON.parse(result?.body);
               if(getEnv() !== envs.PROD){
                  console.log(`Data received from /topic/consolidated_message at ${moment()?.toDate()} - `, resultJson);
               }
             
              //onSocketMsgReceive(resultJson?.socketMssgmap);
              queue.enqueue(resultJson?.socketMssgmap);

              for (let msg of queue) {
                setTimeout(async () => {
                await onSocketMsgReceive(msg);
               }, 1000);
             }
              // [...queue]?.forEach(async(row: any)=>{
              //   // console.log('queue size', queue?.size, count)
              //    await onSocketMsgReceive(row);
              //   });
            }
          );
        },
        {},
        () => {}
      );
    
    
      return () => {
        if (socketConsolidateClient?.connected) {
          socketConsolidateClient?.unsubscribe("/topic/consolidated_message");
          socketConsolidateClient?.disconnect();
        }
        if(queue){
          queue?.clear()
        }
      };
  }, []);

  const onSocketMsgReceive = (msg:any)=>{
    const contractList = _.get(msg, socketMsgType.CONTRACT);
    const dtcStatusList = _.get(msg, socketMsgType.MATCH_CONTRACT_ACTIVITY);
    if (_.isArray(contractList) && !_.isEmpty(contractList)) {
      let socketRows = [...contractList]?.map((item: any) => {
        return item?.messageJson;
      });
      updateTradeStatusToBooked(socketRows)
    }
    if (_.isArray(dtcStatusList) && !_.isEmpty(dtcStatusList)) {
      let socketRows = [...dtcStatusList]?.map((item: any) => {
        return { ...item, id: item?.contract_id + item?.bl?.toLowerCase() };
      });
      updateTradeStatusToSettled(socketRows)
    }

    setTimeout(() => {
      queue?.dequeue()
   }, 1000);

  }
  

  const updateTradeStatusToSettled = (trades: any) => {
    setRowData((previousRows: any) => {
      let currentRows = [...previousRows];
      if(_.isArray(currentRows) && currentRows?.length>0){
        trades?.forEach((trade: any)=>{
          let index = currentRows?.findIndex(
            (t) => t?.uiTradeId === trade?.ui_trade_id
          );
          if (index >= 0) {
            currentRows[index].dtc_status = trade?.dtc_status;
          }
        })
      }
      
      return currentRows;
   });
  };

  const updateTradeStatusToBooked = (trades: any[]) => {
    setRowData((previousRows: any) => {
        let currentRows = [...previousRows];
        if(_.isArray(currentRows) && currentRows?.length>0){
          trades?.forEach((trade: any)=>{
            let index = currentRows?.findIndex(
              (t) => t?.uiTradeId === trade?.ui_trade_id
            );
            if (index >= 0) {
              currentRows[index].status = trade?.ui_status;
              currentRows[index].contract_id = trade?.contract_id;
              if (trade?.rejected_error_reasons?.length > 0) {
                currentRows[index].errorCode =
                trade?.rejected_error_reasons?.includes("Contract added", 0)
                  ? ""
                  : trade?.rejected_error_reasons;
              }
              
            }
          })
        }
        
        return currentRows;
    });
  };

  function validateCusipNTickerNCptyName(updated_Data: any) {
    if (
      updated_Data.cpty_name == null ||
      updated_Data.cpty_name == undefined ||
      updated_Data.cpty_name == "" ||
      updated_Data.cusip == null ||
      updated_Data.cusip == undefined ||
      updated_Data.cusip == "" ||
      updated_Data.tb_ticker == null ||
      updated_Data.tb_ticker == undefined ||
      updated_Data.tb_ticker == ""
    ) {
      updated_Data.status = constants.Error;
    }
  }
  function applyInvalidTickerProps(updated_Data: any) {
    updated_Data.ticker_price = "";
    updated_Data.mkt_price = "";
    updated_Data.cusip = "";
    updated_Data.value = "";
    updated_Data.status = constants.Error;
  }

  useEffect(() => {
    set_CptyData(cptyListContract);
  }, [cptyListContract]);

  useEffect(() => {
    if (
      !_.isNull(cptyListContractMap) &&
      !_.isNull(tickerCusipMaster) &&
      !_.isNull(tickerNameMaster)
    ) {
      setIsInitialRefresh(true);
    }
  }, [cptyListContractMap, tickerCusipMaster, tickerNameMaster]);

  useEffect(() => {
    if (isInitialRefresh) {
      refreshGrid(false);
    }
  }, [isInitialRefresh]);

  useEffect(() => {
    onGetContractBookingServiceHealthCheck();
    onGetTradeStateServiceHealthCheck();
  }, []);

  useEffect(() => {
    tickerSet(tickerListContract);
    setTickerNameMaster(tickerNameMaster);
  }, [tickerListContract, tickerNameMaster]);

  useEffect(() => {
    if (cptyListContract?.length && tickerListContract?.length) {
      setMinimizeContract(true);
    }
  }, [cptyListContract, tickerListContract]);

  let SaveTradDataArr: any = [];
  let SaveTradObj: any = {};
  let objDataMatch = {};
  let objData = {};

  const onGetContractBookingServiceHealthCheck = async () => {
    let healthStatus = await getContractBookingServiceHealthCheck();
    if (!healthStatus || healthStatus?.status === 503 || !healthStatus?.ok) {
      setOpen(true);
      setSnackbarMessage(messages.contractBookMessage);
    }
  };

  const onGetTradeStateServiceHealthCheck = async () => {
    let healthStatus = await getTradeStateServiceHealthCheck();
    if (!healthStatus || healthStatus?.status === 503 || !healthStatus?.ok) {
      setOpen(true);
      setSnackbarMessage(messages.tradeManagementMessage);
    }
  };

  const onSubmit = async (DataforBookContract: any) => {
    let arrayDataforBookContract: any = [];
    let objDataforBookContract: any = {};
    let objDataforBookContracts: any = {};
    let objDataforBookContractisMatch: any = {};
    SaveTradDataArr = [];
    SaveTradObj = {};
    objDataMatch = {};
    objData = {};

    document.getElementsByTagName("input")[0].focus();
    let hasError = true;

    if (checkedRadioContract) {
      objData = {
        b_l: tradeType === "" ? "B" : tradeType,
        cpty_name: counterPartyinConttract,
        tb_ticker: tickerContract,
        ticker_price: tickerPrice,
        mark:
          markFieldEvent !== ""
            ? parseInt(markFieldEvent)
            : parseInt(markField),
        quantity: quantityContract,
        rate: rateFieldContract,
        cpty_id: markFieldContract,
        value:
          contractValueEventContract !== ""
            ? contractValueEventContract
            : contractValueContract,
        contract_price: contractPriceContract,
        profit_center: profitCenterFieldContract,
        div: validateDiv(divTextFieldContract),
        term_date: termDateFieldContract,
        c_n: cashNonCashContract,
        trade_date: "06/14/2022",
        settle_date: "06/14/2022",
        Collatoral_code: "USD",
        status: "sent",
        cusip: "@37833100",
        daily_accruals: "956.22",
        contract_id: "14-JUN 22-C2257-1",
      };

      objDataforBookContracts = {
        collatoral_code: "C",
        collatoral_type: "",
        country: "",
        cpty: markFieldContract,
        currency: "",
        div: validateDiv(divTextFieldContract),
        external_contract_id: "",
        external_source: "",
        loan_value:
          contractValueEventContract !== ""
            ? contractValueEventContract
            : contractValueContract,
        mark:
          markFieldEvent !== ""
            ? parseInt(markFieldEvent)
            : parseInt(markField),
        profit_center: profitCenterFieldContract,
        quantity: quantityContract,
        rate: rateFieldContract,
        symbol: tickerContract,
        term_date: termDateFieldContract,
        ticker: tickerContract,
        trader: user.userName,
        type: tradeType === "" ? "B" : tradeType,
        tickerCusip: tickerCusip,
        cpty_name: counterPartyinConttract,
        mkt_price: tickerPrice,
        contract_price: contractPriceContract,
        c_n: cashNonCashContract,
      };

      arrayDataforBookContract.push(objDataforBookContracts);
      if (hasError === true) {
        onOpenContractValueByCptyID(arrayDataforBookContract);
        setMinimizeContract(true);

        setNeedToClearForm(true);
        setTimeout(() => {
          setNeedToClearForm(false);
        }, 500);
      }
    } else if (!checkedRadioContract) {
      objData = {
        b_l: "B",
        cpty_name: counterPartyinConttract,
        tb_ticker: tickerContract,
        ticker_price: tickerPrice,
        mark:
          markFieldEvent !== ""
            ? parseInt(markFieldEvent)
            : parseInt(markField),
        quantity: quantityContract,
        rate: rateFieldContract,
        cpty_id: markFieldContract,
        value:
          contractValueEventContract !== ""
            ? contractValueEventContract
            : contractValueContract,
        contract_price: contractPriceContract,
        profit_center: profitCenterFieldContract,
        div: validateDiv(divTextFieldContract),
        c_n: cashNonCashContract,
        term_date: termDateFieldContract,
        trade_date: "06/14/2022",
        settle_date: "06/14/2022",
        Collatoral_code: "USD",
        status: "sent",
        cusip: "@37833100",
        daily_accruals: "956.22",
        contract_id: "14-JUN 22-C2257-1",
      };
      objDataMatch = {
        b_l: "L",
        cpty_name: counterPartyinConttractisMatch,
        tb_ticker: tickerContract,
        ticker_price: tickerPrice,
        mark:
          markFieldisMatchEvent !== ""
            ? parseInt(markFieldisMatchEvent)
            : parseInt(markFieldisMatch),
        quantity: quantityContract,
        rate: rateFieldContractisMatch,
        cpty_id: markFieldContractisMatch,
        value:
          contractValueContractEventisMatch !== ""
            ? contractValueContractEventisMatch
            : contractValueContract,
        contract_price: contractPriceContractisMatch,
        profit_center: profitCenterFieldContractisMatch,
        div: validateDiv(divTextFieldContractisMatch),
        term_date: termDateFieldContract,
        c_n: cashNonCashMatchContract,
        trade_date: "06/14/2022",
        settle_date: "06/14/2022",
        Collatoral_code: "USD",
        status: "sent",
        cusip: "@37833100",
        daily_accruals: "956.22",
        contract_id: "14-JUN 22-C2257-1",
      };

      objDataforBookContract = {
        collatoral_code: "C",
        collatoral_type: "",
        country: "",
        cpty: markFieldContract,
        currency: "",
        div: validateDiv(divTextFieldContract),
        external_contract_id: "T",
        external_source: "",
        loan_value:
          contractValueEventContract !== ""
            ? contractValueEventContract
            : contractValueContract,
        mark:
          markFieldEvent !== ""
            ? parseInt(markFieldEvent)
            : parseInt(markField),
        profit_center: profitCenterFieldContract,
        quantity: quantityContract,
        rate: rateFieldContract,
        symbol: tickerContract,
        term_date: termDateFieldContract,
        ticker: tickerContract,
        type: "B",
        tickerCusip: tickerCusip,
        trader: user.userName,
        cpty_name: counterPartyinConttract,
        mkt_price: tickerPrice,
        contract_price: contractPriceContract,
        c_n: cashNonCashContract,
      };

      arrayDataforBookContract.push(objDataforBookContract);

      objDataforBookContractisMatch = {
        collatoral_code: "C",
        collatoral_type: "",
        country: "",
        cpty: markFieldContractisMatch,
        currency: "",
        div: validateDiv(divTextFieldContractisMatch),
        external_contract_id: "T",
        external_source: "",
        loan_value:
          contractValueContractEventisMatch !== ""
            ? contractValueContractEventisMatch
            : contractValueContract,
        mark:
          markFieldisMatchEvent !== ""
            ? parseInt(markFieldisMatchEvent)
            : parseInt(markFieldisMatch),
        profit_center: profitCenterFieldContractisMatch,
        quantity: quantityContract,
        rate: rateFieldContractisMatch,
        symbol: tickerContract,
        term_date: termDateFieldContract,
        ticker: tickerContract,
        type: "L",
        tickerCusip: tickerCusip,
        trader: user.userName,
        cpty_name: counterPartyinConttractisMatch,
        mkt_price: tickerPrice,
        contract_price: contractPriceContractisMatch,
        c_n: cashNonCashMatchContract,
        uiTradeId: 0,
      };

      arrayDataforBookContract.push(objDataforBookContractisMatch);

      if (hasError === true) {
        onOpenContractValueByCptyID(arrayDataforBookContract);
        setMinimizeContract(true);

        setNeedToClearForm(true);
        setTimeout(() => {
          setNeedToClearForm(false);
        }, 1500);
      }
    }
  };

  const onGetTradesStateByUserName = async (
    isUserAction: boolean,
    delay: boolean = false
  ): Promise<boolean> => {
    if (delay) {
      await sleep(constants.TRADESTATE_SLEEP_DELAY);
    }

    let objForsaveTradeData: any = {};
    let arrForsaveTradeData: any = [];
    var accessToken = window.localStorage.getItem("refreshtoken");
    let getTradesStateByUserNameRes: any = await getTradesStateByUserName(
      user.userName,
      user.tokenType,
      accessToken
    );
    if (!getTradesStateByUserNameRes) {
      setOpen(true);
      setSnackbarMessage(messages.tradeManagementMessage);
      setIsLoading(false);
      setIsTradeServiceDown(true);
      if (isUserAction) {
        swal({
          title: constants.Error,
          text: messages.tradeManagementMessage,
          icon: constants.swalIconError,
          dangerMode: true,
          closeOnClickOutside: false,
        });
      }
      return Promise.reject(false);
    } else if (getTradesStateByUserNameRes?.status === 401) {
      setIsTradeServiceDown(false);
      setIsLoading(false);
      navigate("/signin");
    }
    try {
      if (getTradesStateByUserNameRes?.status === 200) {
        let getTradesStateByUserNameData: any =
          await getTradesStateByUserNameRes.json();
        setIsTradeServiceDown(false);
        //let tickerListMaster = JSON.parse(JSON.stringify(tickerListContract));
        getTradesStateByUserNameData.map((item: any) => {
          const c_n = /[BN]/.test(item.coll_type) ? "N" : "C";

          objForsaveTradeData = {
            b_l: item.bl,
            cpty_name: item.cpty_name,
            tb_ticker: item.ticker,

            ticker_price: item.mkt_price,
            mark: item.mark,
            quantity: item.quantity,
            rate: item.rate,
            cpty_id: item.cpty_id,
            value: item.colvalue,
            contract_price: item.contract_price,
            profit_center: item.profit_center,
            div: validateDiv(item.div),
            c_n: c_n,
            term_date:
              item.term_date === null || item.term_date === undefined
                ? ""
                : moment(item.term_date).format("MM/DD/YYYY"),
            trade_date: "",
            settle_date: "",
            Collatoral_code: "USD",
            status: item.ui_status,
            cusip: item.sec_id,
            daily_accruals: "",
            contract_id: item.contract_id,
            uiTradeId: item.ui_trade_id,
            errorCode: getErrorCodeFromItem(item),
            dtc_status: item?.dtc_status
          };
          let ticker = tickerNameMaster?.get(
            objForsaveTradeData?.tb_ticker?.toUpperCase()
          );
          if (ticker) {
            objForsaveTradeData.ticker_price = ticker?.price?.toFixed(2);
            objForsaveTradeData.cusip = ticker?.cusip;
          } else {
            objForsaveTradeData.errorCode = "Invalid Ticker";
          }

          arrForsaveTradeData.push(objForsaveTradeData);
        });

        setRowData([...mapRowId([...arrForsaveTradeData])]);
        setIsLoading(false);
        queue?.clear()
      }
      setShowClearLoader(false);
      return Promise.resolve(true);
    } catch (err) {
      isContractStatusEnabled = true;
      setShowClearLoader(false);
      setIsLoading(false);
      setIsTradeServiceDown(false);
      return Promise.reject(false);
    }
  };

  useEffect(() => {
    if (
      !_.isNull(cptyListContractMap) &&
      !_.isNull(tickerCusipMaster) &&
      !_.isNull(tickerNameMaster)
    ) {
    }
  }, [cptyListContractMap, tickerCusipMaster, tickerNameMaster]);

  const onAddGridSaveTradData = async (getTradesStateByUserNameData: any) => {
    setGridLoder(true);
    let TempArrayForTrad: any = [];
    let TempObjForTrad: any = {};
    let cpty_name: any = "";
    let mark: any = "";
    let tb_ticker: any = "";
    let cusip: any = "";
    let price: any = "";
    let contract_price: any = "";
    let value: any = "";
    let saveTradeStatus: any = "New";
    let FilterTickerData: any = {};
    let FilterCptyData: any = {};
    let CurrentDate = new Date();
    let CurrentDateLength = moment(CurrentDate).format("MM/DD/YYYY");

    for (let i = 0; i < getTradesStateByUserNameData.length; i++) {
      if (getTradesStateByUserNameData[i].bl === "") {
        saveTradeStatus = constants.Error;
      } else if (
        getTradesStateByUserNameData[i].sec_id === undefined ||
        getTradesStateByUserNameData[i].sec_id === ""
      ) {
        saveTradeStatus = constants.Error;
      } else if (
        getTradesStateByUserNameData[i].ticker === undefined ||
        getTradesStateByUserNameData[i].ticker === ""
      ) {
        saveTradeStatus = constants.Error;
      } else if (
        getTradesStateByUserNameData[i].quantity < 0 ||
        getTradesStateByUserNameData[i].quantity === null ||
        getTradesStateByUserNameData[i].quantity === ""
      ) {
        saveTradeStatus = constants.Error;
      } else if (
        getTradesStateByUserNameData[i].rate < -999.9999 ||
        getTradesStateByUserNameData[i].rate > 999.9999 ||
        getTradesStateByUserNameData[i].rate === undefined ||
        getTradesStateByUserNameData[i].rate === ""
      ) {
        saveTradeStatus = constants.Error;
      } else if (
        moment(getTradesStateByUserNameData[i].term_date).format("MM/DD/YYYY") <
        CurrentDateLength
      ) {
        saveTradeStatus = constants.Error;
      } else if (
        getTradesStateByUserNameData[i].term_date === "" ||
        getTradesStateByUserNameData[i].term_date === undefined
      ) {
        saveTradeStatus = "New";
      } else {
        saveTradeStatus = "New";
      }

      let isTickerFound = false;
      let cptyContract = tickerNameMaster.get(
        getTradesStateByUserNameData[i].ticker
      );
      if (cptyContract) {
        isTickerFound = true;
      }

      if (!isTickerFound) {
        getTradesStateByUserNameData[i].rejected_error_reasons =
          messages.InvalidTicker;
      }

      if (getTradesStateByUserNameData[i].sec_id !== null) {
        let tickerByCusip = tickerCusipMaster?.get(
          getTradesStateByUserNameData[i]?.sec_id?.trim()
        );
        if (tickerByCusip) {
          price = tickerByCusip.price?.toFixed(2);
          tb_ticker = tickerByCusip?.ticker;
        }
      } else if (getTradesStateByUserNameData[i].ticker !== null) {
        let tickerByName = tickerNameMaster.get(
          getTradesStateByUserNameData[i]?.ticker?.toUpperCase()
        );
        if (tickerByName) {
          cusip = tickerByName?.cusip;
          price = tickerByName?.price?.toFixed(2);
        }
      } else if (getTradesStateByUserNameData[i].ticker == null) {
        let counterPartyContract = cptyListContractMap.get(
          getTradesStateByUserNameData[i]?.cpty_id?.toUpperCase()
        );
        if (counterPartyContract) {
          cusip = counterPartyContract?.cusip;
          price = counterPartyContract?.price?.toFixed(2);
        }
      }

      for (let c = 0; c < cptyListContract.length; c++) {
        if (
          cptyListContract[c].cptyId === getTradesStateByUserNameData[i].cpty_id
        ) {
          cpty_name = cptyListContract[c].name;
          mark =
            getTradesStateByUserNameData[i].bl == "L"
              ? cptyListContract[c].loan_mark
              : cptyListContract[c].borrow_mark;
        }
      }

      let contractValue: any = (parseFloat(price) * parseFloat(mark)) / 100;

      let hseIndIsone: any = Math.ceil(contractValue);
      let roundingNext25: any = Math.ceil(contractValue / 0.25) * 0.25;
      let roundingNext50: any = Math.ceil(contractValue / 0.5) * 0.5;

      let roundDone: any =
        hseIndIsone * getTradesStateByUserNameData[i].quantity;
      let roundDoneNext25: any =
        roundingNext25 * getTradesStateByUserNameData[i].quantity;
      let roundDoneNext50: any =
        roundingNext50 * getTradesStateByUserNameData[i].quantity;

      if (cptyListContract[i].hse_ind === "U") {
        if (cptyListContract[i].hse_rnd === "1") {
          value = !isNaN(roundDone) ? roundDone.toFixed(0) : 0;
          contract_price = !isNaN(hseIndIsone) ? hseIndIsone.toFixed(2) : 0;
        } else if (cptyListContract[i].hse_rnd === 0.25) {
          value = !isNaN(roundDoneNext25) ? roundDoneNext25.toFixed(0) : 0;
          contract_price = !isNaN(roundingNext25)
            ? roundingNext25.toFixed(2)
            : 0;
        } else if (cptyListContract[i].hse_rnd === 0.5) {
          value = !isNaN(roundDoneNext50) ? roundDoneNext50.toFixed(0) : 0;
          contract_price = !isNaN(roundingNext50)
            ? roundingNext50.toFixed(2)
            : 0;
        } else if (cptyListContract[i].hse_rnd === "0") {
          value = !isNaN(roundDone) ? roundDone.toFixed(0) : 0;
          contract_price = !isNaN(contractValue) ? contractValue.toFixed(2) : 0;
        } else {
          value = !isNaN(roundDone) ? roundDone.toFixed(0) : 0;
          contract_price = !isNaN(hseIndIsone) ? hseIndIsone.toFixed(2) : 0;
        }
      } else if (cptyListContract[i].hse_ind === "N") {
        value = !isNaN(roundDone) ? roundDone.toFixed(0) : 0;
        contract_price = !isNaN(contractValue) ? contractValue.toFixed(2) : 0;
      }
      TempObjForTrad = {
        b_l: getTradesStateByUserNameData[i].bl,
        cpty_name: cpty_name,
        tb_ticker:
          getTradesStateByUserNameData[i].ticker == null
            ? tb_ticker
            : getTradesStateByUserNameData[i].ticker,
        ticker_price: price,
        mark: mark,
        quantity: getTradesStateByUserNameData[i].quantity,
        rate: getTradesStateByUserNameData[i].rate,
        cpty_id: getTradesStateByUserNameData[i].cpty_id,
        value: value,
        contract_price: contract_price,
        profit_center: getTradesStateByUserNameData[i].profit_center,
        div: validateDiv(getTradesStateByUserNameData[i].div),
        c_n: getTradesStateByUserNameData[i].coll_type,
        term_date:
          getTradesStateByUserNameData[i].term_date === null
            ? ""
            : moment(getTradesStateByUserNameData[i].term_date).format(
                "MM/DD/YYYY"
              ),
        trade_date: "",
        settle_date: "",
        Collatoral_code: "USD",
        status:
          getTradesStateByUserNameData[i].ui_status === null
            ? saveTradeStatus
            : getTradesStateByUserNameData[i].ui_status,
        cusip:
          getTradesStateByUserNameData[i].sec_id == "" ||
          getTradesStateByUserNameData[i].sec_id == null
            ? cusip
            : getTradesStateByUserNameData[i].sec_id.trim() == ""
            ? cusip
            : getTradesStateByUserNameData[i].sec_id,
        daily_accruals: "",
        contract_id: getTradesStateByUserNameData[i].contract_id,
        uiTradeId: getTradesStateByUserNameData[i].ui_trade_id,
        errorCode:
          getTradesStateByUserNameData[i].ui_status === "Failed" &&
          getTradesStateByUserNameData[i].rejected_error_reasons,
      };
      TempArrayForTrad.push(TempObjForTrad);
    }

    setGridLoder(false);
    return TempArrayForTrad;
  };

  const onOpenContractValueByCptyID = async (Data: any) => {
    let response: any = "";
    let result: any = "";
    let reqObj: any = {};
    let reqArr: any = [];
    for (let d = 0; d < Data.length; d++) {
      Data[d].type = Data[d].type.toUpperCase();
      reqObj = {
        cpty_id: Data[d].cpty,
        bl: Data[d].type,
      };
      reqArr.push(reqObj);
    }
    var accessToken = window.localStorage.getItem("refreshtoken");
    response = await getOpenContractValueByCptyID(
      reqArr,
      user.tokenType,
      accessToken
    );
    if (!response) {
      setOpen(true);
      setSnackbarMessage(messages.contractBookMessage);
      swal({
        title: constants.Error,
        text: messages.contractBookMessage,
        icon: constants.swalIconError,
        dangerMode: true,
        closeOnClickOutside: false,
      });
    } else if (response && response != undefined && response.status === 200) {
      result = await response.json();
      for (let d = 0; d < Data.length; d++) {
        let dData: any = Data[d];
        // if user edits value, it's converted to string. parse it into a float.
        if (
          typeof dData.loan_value === "string" &&
          !Number.isNaN(parseFloat(dData.loan_value))
        ) {
          dData.loan_value = parseFloat(dData.loan_value);
          dData.contract_price = dData.loan_value / dData.quantity;
        }
        if (result.result.length > 0) {
          for (let i = 0; i < result.result.length; i++) {
            let iResult: any = result.result[i];
            if (iResult?.error === "Success") {
              let counterPartyContract = cptyListContractMap.get(
                iResult?.cpty_id?.toUpperCase()
              );
              if (counterPartyContract) {
                const borrowAcctLimit = counterPartyContract?.borr_acct_limit;
                const loanAcctLimit = counterPartyContract?.loan_acct_limit;
                const outstandingValue = iResult?.total_col_value;
                const newValue = dData.loan_value + outstandingValue;
                if (iResult.bl === "B" && dData.type === "B") {
                  if (newValue > borrowAcctLimit) {
                    const BorrowVal = borrowAcctLimit - newValue;
                    setThisContractVal(formatter.format(dData.loan_value));
                    setBorrowValVal(formatter.format(BorrowVal));
                    setBorrAcctLimit(formatter.format(borrowAcctLimit));
                    setOutstandingBorrow(formatter.format(outstandingValue));
                    setBorrCptyIdModal(dData.cpty);
                    SetGetCptyDataForBookContractBorrow([Data[d]]);
                    setBorrowValOpen(true);
                  } else {
                    onbookContract([Data[d]]);
                  }
                } else if (iResult.bl === "L" && dData.type === "L") {
                  if (newValue > loanAcctLimit) {
                    const LoanVal = loanAcctLimit - newValue;
                    setThisContractVal(formatter.format(dData.loan_value));
                    setLoanValVal(formatter.format(LoanVal));
                    setLoanAcctLimit(formatter.format(loanAcctLimit));
                    setOutstandingLoan(formatter.format(outstandingValue));
                    setLoanCptyIdModal(dData.cpty);
                    SetGetCptyDataForBookContractLoan([Data[d]]);
                    setLoanValOpen(true);
                  } else {
                    onbookContract([Data[d]]);
                  }
                }
              }
            }
          }
        } else {
          onbookContract(Data[d]);
        }
      }
    } else if (response && response?.status === 401) {
      navigate("/signin");
    } else {
      setOpen(true);
      setSnackbarMessage(messages.contractBookMessage);
    }
  };

  const onClickBorrowValYes = () => {
    onbookContract(getCptyDataForBookContractBorrow);
    setBorrowValOpen(false);
  };
  const onClickBorrowValNo = () => {
    setBorrowValOpen(false);
    setIsSubmitDisabledToggle(!isSubmitDisabledToggle);
  };
  const onClickLoanValYes = () => {
    onbookContract(getCptyDataForBookContractLoan);
    setLoanValOpen(false);
  };
  const onClickLoanValNo = () => {
    setLoanValOpen(false);
    setIsSubmitDisabledToggle(!isSubmitDisabledToggle);
  };

  const onstatusContract = async () => {
    let tempRowData: any = [...rowData];
    let statusContractObj: any = {};
    let statusContractArr: any = [];

    try {
      let statusContractRes: any = "";

      // create the request
      for (let t = 0; t < tempRowData.length; t++) {
        if (
          constants.UI_STATUS_SENT.localeCompare(tempRowData[t].status) === 0
        ) {
          statusContractObj = {
            bl: tempRowData[t].b_l,
            contract_id: tempRowData[t].contract_id,
            cpty: tempRowData[t].cpty_id,
            cusip: tempRowData[t].cusip,
            ui_trade_id: tempRowData[t].uiTradeId,
          };
          statusContractArr.push(statusContractObj);
        }
      }

      // make the request and process response
      if (statusContractArr.length > 0) {
        var accessToken = window.localStorage.getItem("refreshtoken");
        statusContractRes = await statusContract(
          statusContractArr,
          user.tokenType,
          accessToken
        );
        if (!statusContractRes) {
          setOpen(true);
          setSnackbarMessage(messages.contractBookMessage);
        } else if (statusContractRes.status === 200) {
          const statusContract = await statusContractRes.json();
          for (let r = 0; r < tempRowData.length; r++) {
            for (let i = 0; i < statusContract.length; i++) {
              if (
                tempRowData[r].uiTradeId == statusContract[i].uiTradeId &&
                statusContract[i].uiStatus !== "Sent"
              ) {
                if (statusContract[i].errorCode) {
                  tempRowData[r].errorCode = statusContract[
                    i
                  ].errorCode.includes("Contract added", 0)
                    ? ""
                    : statusContract[i].errorCode;
                }
                tempRowData[r].status = statusContract[i].uiStatus;

                if (
                  constants.UI_STATUS_BOOKED.localeCompare(
                    statusContract[i].uiStatus
                  ) === 0
                ) {
                  tempRowData[r].contract_id = statusContract[i].contract_id;
                }
              }
            }
          }

          if (isContractStatusEnabled) {
            setRowData([...mapRowId([...tempRowData])]);
          }
        } else if (statusContractRes.status === 401) {
          navigate("/signin");
        }
      }
    } catch (err) {}
  };

  const onbookContract = async (DataforBookContract: any) => {
    isContractStatusEnabled = false;
    let bookContractRes: any = "";
    let statusRowData: any = [...rowData];
    let errors: any = [];
    try {
      var accessToken = window.localStorage.getItem("refreshtoken");
      bookContractRes = await bookContract(
        DataforBookContract,
        user.tokenType,
        accessToken
      );
      setBookContractStatusResponse(bookContractRes);
      if (!bookContractRes) {
        setOpen(true);
        setSnackbarMessage(messages.contractBookMessage);
        swal({
          title: constants.Error,
          text: messages.contractBookMessage,
          icon: constants.swalIconError,
          dangerMode: true,
          closeOnClickOutside: false,
        });
        setIsBulkSubmitRunning(false);
      } else if (bookContractRes.status === 200) {
        let bookContractData = await bookContractRes.json();

        for (let i = 0; i < bookContractData.length; i++) {
          if (
            bookContractData[i].hasError === true &&
            bookContractData[0].errorCategory !== "Invalid quantity."
          ) {
            setInvalidQuantity(false);
          }

          if (bookContractData[i].hasError === true) {
            errors.push(
              bookContractData[i].status + " " + bookContractData[i].error
            );
          }
          let data = {
            bl: bookContractData[i].contractDTO.type,
            contract_id: bookContractData[i].contractDTO.external_contract_id,
            cpty: bookContractData[i].contractDTO.cpty,
            cusip: bookContractData[i].cusip,
            ui_trade_id: bookContractData[i].uiTradeId,
          };
          objData = {
            b_l: bookContractData[i].contractDTO.type,
            cpty_name: counterPartyinConttract,
            tb_ticker: bookContractData[i].contractDTO.ticker,
            ticker_price: tickerPrice,
            mark: bookContractData[i].contractDTO.mark,
            quantity: bookContractData[i].contractDTO.quantity,
            rate: bookContractData[i].contractDTO.rate,
            cpty_id: bookContractData[i].contractDTO.cpty,
            value: bookContractData[i].contractDTO.loan_value,
            contract_price: bookContractData[i].contractDTO.contract_price,
            profit_center:
              bookContractData[i].contractDTO.profit_center !== ""
                ? bookContractData[i].contractDTO.profit_center.toUpperCase()
                : " ",
            div: validateDiv(bookContractData[i].contractDTO.div),
            c_n: cashNonCashContract.toUpperCase(),
            term_date: bookContractData[i].contractDTO.term_date,
            trade_date: "",
            settle_date: "",
            Collatoral_code: "USD",
            status:
              bookContractData[i].status == "O"
                ? constants.UI_STATUS_SENT
                : bookContractData[i].status,
            cusip: bookContractData[i].cusip,
            daily_accruals: "",
            contract_id: "",
            uiTradeId: bookContractData[i].uiTradeId,
            errorCode: "",
          };
          SaveTradObj = {
            uiTradeId: bookContractData[i].uiTradeId,
            book: "",
            sm_id: 0,
            sec_id: 1,
            sec_id_type: 1,
            cpty_id: bookContractData[i].contractDTO.cpty,
            ccy: "",
            bl: bookContractData[i].contractDTO.type,
            status: bookContractData[i].status,
            quantity: bookContractData[i].contractDTO.quantity,
            colvalue: 0,
            mktval: 0,
            div: validateDiv(bookContractData[i].contractDTO.div),
            rate: bookContractData[i].contractDTO.rate,
            profit_center:
              bookContractData[i].contractDTO.profit_center !== ""
                ? bookContractData[i].contractDTO.profit_center.toUpperCase()
                : "P",
            smnt_date: new Date(),
            term_date: bookContractData[i].contractDTO.term_date,
            contract_id: bookContractData[i].contractDTO.cpty,
            ext_ref_id: "",
            coll_type: 1,
            coll_mgn: 0,
            coll_exp: 0,
            income: 0,
            finance: 0,
            date: new Date(),
            updatetime: new Date(),
            correlation_id: "",
            contract_status: constants.UI_STATUS_NEW,
            rejected_error_reasons: "",
            trader: user.userName,
            trader_session: "",
            ui_status: bookContractData[i].status,
            ticker: bookContractData[i].contractDTO.ticker,
            cpty_name: bookContractData[i].cpty_name,
            contract_price: bookContractData[i].contract_price,
            mark: bookContractData[i].mark,
          };
          SaveTradDataArr.push(SaveTradObj);
          statusRowData.push(objData);
        }
        setTradeType("");
        setCounterPartyinContract("");
        setTickerContract("");
        setQuantityContract("");
        setRateFieldContract("");
        setMarkFieldContract("");
        setContractValueContract("");
        setProfitCenterFieldContract("");
        setDivTextFieldContract("");
        setTermDateFieldContract("");
        setCashNonCashContract("");
        setBaLinContractisMatch("");
        setCounterPartyinContractisMatch("");
        setTickerContractisMatch("");
        setQuantityContractisMatch("");
        setRateFieldContractisMatch("");
        setMarkFieldContractisMatch("");
        setContractValueContractisMatch("");
        setProfitCenterFieldContractisMatch("");
        setDivTextFieldContractisMatch("");
        setCashNonCashMatchContract("");
        setTermDateFieldContract("");

        if (errors.length > 0) {
          errors = _.uniq(errors);
          let error = messages.statuserror + "\n\n Error(s): \n";
          errors.map((e: any) => {
            error = error + e + "\n";
          });
          swal({
            title: constants.Error,
            text: error,
            dangerMode: true,
            closeOnClickOutside: false,
          });
        }
      } else if (bookContractRes.status === 401) {
        navigate("/signin");
        setIsBulkSubmitRunning(false);
      } else if (bookContractRes.status != 200) {
        let bookContractJson = await bookContractRes.json();
        let error = messages.statuserror;
        if (bookContractJson.error) error = bookContractJson.error;
        swal({
          title: constants.swalIconError,
          text: error,
          dangerMode: true,
          closeOnClickOutside: false,
        });
        setIsBulkSubmitRunning(false);
      }
    } catch (err) {
      swal({
        title: constants.swalIconError,
        text: messages.statuserror,
        // icon: "warning",
        dangerMode: true,
        closeOnClickOutside: false,
      });
    } finally {
      setIsBulkSubmitRunning(false);
      await onGetTradesStateByUserName(true);
      setIsSubmitDisabledToggle(!isSubmitDisabledToggle);
    }
  };

  // useEffect(() => {
  //   const returnInterval = setInterval(() => {
  //     if (isContractStatusEnabled) onstatusContract();
  //     else isContractStatusEnabled = true;
  //   }, 5000);
  //   return () => clearInterval(returnInterval);
  // }, [rowData]);

  const onSaveTradeStateList = async (SaveTradData: any) => {
    let SaveTradeStateRes: any = "";

    let failedRows: any = [];
    setInvalidFileEntries("");
    let skippedRowNumber = "";
    var accessToken = window.localStorage.getItem("refreshtoken");
    SaveTradeStateRes = await SaveTradeStateList(
      SaveTradData,
      user.tokenType,
      accessToken
    );
    if (!SaveTradeStateRes) {
      swal({
        title: constants.Error,
        text: messages.tradeManagementMessage,
        icon: constants.swalIconError,
        dangerMode: true,
        closeOnClickOutside: false,
      });
      setIsBulkUploadRunning(false);
    } else if (SaveTradeStateRes?.status === 200) {
      let saveTradeReqRes: any = await SaveTradeStateRes?.json();
      for (let i = 0; i < saveTradeReqRes?.result_set?.length; i++) {
        if (saveTradeReqRes.result_set[i].status === "INTERNAL_SERVER_ERROR") {
          failedRows.push(SaveTradData[i]);
          skippedRowNumber = skippedRowNumber + "," + SaveTradData[i].rowIndex;
        }
      }

      if (failedRows.length > 0) {
        setInvalidFileEntries(skippedRowNumber);
        setShowInvalidFilePopUp(true);
      }
      onGetTradesStateByUserName(true).then(() =>
        setIsBulkUploadRunning(false)
      );
      onClear()
    } else if (SaveTradeStateRes?.status === 401) {
      navigate("/signin");
    }
  };

  const ref: any = useRef(null);

  const onClear = () => {
    setExcelFileName("");
  };

  const onClearAll = () => {
    if (totalSelectedRows?.length > 0) {
      let selectTempArr: any = [];
      let countDelet: any = 0;

      for (let s = 0; s < totalSelectedRows.length; s++) {
        if (
          totalSelectedRows[s]["status"] !== constants.UI_STATUS_NEW &&
          totalSelectedRows[s]["status"] !== constants.Error &&
          totalSelectedRows[s]["status"] !== constants.UI_STATUS_FAILED &&
          totalSelectedRows[s]["status"] !== constants.UI_STATUS_BOOKED &&
          totalSelectedRows[s]["status"] !== constants.UI_STATUS_WARNING
        ) {
          setExcelDataClearPopOpen(true);
          break;
        } else if (
          totalSelectedRows[s]["status"] === constants.UI_STATUS_NEW ||
          totalSelectedRows[s]["status"] === constants.Error ||
          totalSelectedRows[s]["status"] === constants.UI_STATUS_FAILED ||
          totalSelectedRows[s]["status"] === constants.UI_STATUS_BOOKED ||
          totalSelectedRows[s]["status"] === constants.UI_STATUS_WARNING
        ) {
          selectTempArr.push(totalSelectedRows[s]["uiTradeId"]);
        }
      }

      if (disableClearBtn === false) {
        onDeleteTradeState(selectTempArr);
      }

      setworkbookData([]);
      setisNoRecordsSelectedWarning(false);
    } else {
      setisNoRecordsSelectedWarning(true);
    }
  };

  const onDeleteTradeState = async (uiTradeId: any) => {
    setShowClearLoader(true);
    var accessToken = window.localStorage.getItem("refreshtoken");
    let deleteTradeStateRes: any = await deleteTradeState(
      uiTradeId,
      user.tokenType,
      accessToken
    );
    if (!deleteTradeStateRes) {
      swal({
        title: constants.Error,
        text: messages.tradeManagementMessage,
        icon: constants.swalIconError,
        dangerMode: true,
        closeOnClickOutside: false,
      });
      setShowClearLoader(false);
    } else if (deleteTradeStateRes?.status === 401) {
      setShowClearLoader(false);
      navigate("/signin");
    }
    // let deleteTradeStateData: any = deleteTradeStateRes.json();
    onGetTradesStateByUserName(true);
  };

  const onChange = (e: any) => {
    setExcelLoder(true);
    //turning the flag true, so it can represents that the uploading process has begun.
    setIsBulkUploadRunning(true);
    makeRequest(
      "GET",
      `${URL.createObjectURL(e.target.files[0])}`,
      function (data) {
        var workbook = convertDataToWorkbook(data);
        populateGrid(workbook, e.target.files[0].name);
        setworkbookData(workbook);
      },
      function (error) {
        //turning the flag false, so it can represents that the uploading process has been stoped.
        setIsBulkUploadRunning(false);
        throw error;
      }
    );
  };

  const refreshGrid = async (isAction: boolean) => {
    let rows = [...rowData];
    setRowData([...mapRowId(rows)]);
    setIsLoading(true);
    await onGetTradesStateByUserName(isAction);
    let CurrentDateforRefresh: any = new Date();
    setRefresh(
      CurrentDateforRefresh.toLocaleString("en-US", {
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })
    );
    if(queue){
      queue?.clear()
    }
  };

  const makeRequest = (
    method: string,
    url: string,
    success: (data: any) => void,
    error: (error: any) => void
  ) => {
    var httpRequest = new XMLHttpRequest();
    httpRequest.open("GET", url, true);
    httpRequest.responseType = "arraybuffer";

    httpRequest.open(method, url);
    httpRequest.onload = function () {
      success(httpRequest.response);
    };
    httpRequest.onerror = function () {
      error(httpRequest.response);
    };
    httpRequest.send();
  };
  const convertDataToWorkbook = (dataRows: any) => {
    var data = new Uint8Array(dataRows);
    var arr = [];
    for (var i = 0; i !== data.length; ++i) {
      arr[i] = String.fromCharCode(data[i]);
    }
    var bstr = arr.join("");
    return XLSX.read(bstr, { type: "binary" });
  };

  const onOpenContractValueByCptyIDBulk = async (
    rowsCount: any,
    worksheet: any,
    columns: any
  ) => {
    let getOpenContractValueByCptyIDRes: any = "";
    let getOpenContractValueByCptyIDData: any = "";
    let conValByCptArr: any = [];
    let new_contract_value: any = "";
    let rowIndex = 2;
    let totalRows: any[] = [];
    while (rowsCount >= rowIndex) {
      const row: any = {};
      let workRowA =
        worksheet["A" + rowIndex] == undefined
          ? ""
          : worksheet["A" + rowIndex].v;
      if (workRowA !== "#") {
        Object.keys(columns).forEach(function (column) {
          row[columns[column]] = worksheet[column + rowIndex]?.w;
        });
      }
      row.b_l =
        row.b_l == undefined || row.b_l == null
          ? row.b_l
          : row.b_l.trim().toUpperCase();
      if (
        row.cpty_id != undefined &&
        row.cpty_id != 0 &&
        row.cpty_id != null &&
        row.b_l &&
        row.b_l != null &&
        row.b_l != undefined
      ) {
        let cptyId =
          row?.cpty_id && row.cpty_id?.length >= 1 && row.cpty_id?.length < 4
            ? row.cpty_id?.padStart(4, "0")
            : row?.cpty_id;
        cptyId = cptyId && cptyId?.length > 0 ? cptyId?.toUpperCase() : cptyId;
        conValByCptArr.push({
          cpty_id: cptyId,
          bl: row.b_l,
        });
      }
      totalRows.push(row);
      rowIndex++;
    }

    try {
      var accessToken = window.localStorage.getItem("refreshtoken");
      getOpenContractValueByCptyIDRes = await getOpenContractValueByCptyID(
        conValByCptArr,
        user.tokenType,
        accessToken
      );
      if (!getOpenContractValueByCptyIDRes) {
        setOpen(true);
        setSnackbarMessage(messages.contractBookMessage);
      } else if (getOpenContractValueByCptyIDRes.status === 200) {
        getOpenContractValueByCptyIDData =
          await getOpenContractValueByCptyIDRes.json();
        for (let i = 0; i < totalRows.length; i++) {
          totalRows[i].isCreditLimitExceeded = false;
          if (
            getOpenContractValueByCptyIDData.result != null &&
            getOpenContractValueByCptyIDData.result != undefined &&
            getOpenContractValueByCptyIDData.result.length > 0 &&
            totalRows[i].cpty_id != undefined &&
            totalRows[i].cpty_id != 0 &&
            totalRows[i].cpty_id != null
          ) {
            let cptyId =
              totalRows[i]?.cpty_id &&
              totalRows[i].cpty_id?.length >= 1 &&
              totalRows[i].cpty_id?.length < 4
                ? totalRows[i].cpty_id?.padStart(4, "0")
                : totalRows[i]?.cpty_id;
            cptyId =
              cptyId && cptyId?.length > 0 ? cptyId?.toUpperCase() : cptyId;
            let openContract = getOpenContractValueByCptyIDData.result.find(
              (c: any) => c.cpty_id === cptyId
            );
            let cptyContract = cptyListContractMap.get(cptyId);

            let ticker =
              totalRows[i]?.tb_ticker && totalRows[i]?.tb_ticker?.length > 0
                ? totalRows[i]?.tb_ticker?.toUpperCase()
                : totalRows[i]?.tb_ticker;
            ticker = ticker && ticker?.length > 0 ? ticker?.trim() : ticker;
            let tickerContract = tickerListContract.find(
              (t: any) =>
                t?.cusip === totalRows[i]?.cusip ||
                t?.ticker?.toUpperCase() === ticker
            );

            if (
              openContract != undefined &&
              cptyContract != undefined &&
              tickerContract != undefined &&
              openContract?.error === "Success"
            ) {
              let tickerPrice = tickerContract.price.toFixed(2);
              let mark =
                totalRows[i].b_l == "L"
                  ? cptyContract.loan_mark
                  : cptyContract.borrow_mark;
              let contract_price = calculateContractPriceFromValues(
                tickerPrice,
                mark,
                cptyContract
              );
              let quantity: any = 0;
              if (
                totalRows[i].quantity != undefined &&
                totalRows[i].quantity != null &&
                totalRows[i].quantity != ""
              ) {
                quantity = parseFloat(
                  totalRows[i].quantity.replaceAll(",", "")
                );
              }
              let value = contract_price * quantity;
              value =
                isNumber(value) && value > 0
                  ? parseFloat(value.toFixed(2))
                  : value;
              new_contract_value = value + openContract?.total_col_value;
              if (openContract.bl === "B") {
                if (new_contract_value > cptyContract?.borr_acct_limit) {
                  totalRows[i].isCreditLimitExceeded = true;
                  totalRows[i].errorCode = messages.InvalidCreditLimit;
                  totalRows[i].rejected_error_reasons =
                    messages.InvalidCreditLimit;
                }
              } else if (openContract.bl === "L") {
                if (new_contract_value > cptyContract?.loan_acct_limit) {
                  totalRows[i].isCreditLimitExceeded = true;
                  totalRows[i].errorCode = messages.InvalidCreditLimit;
                  totalRows[i].rejected_error_reasons =
                    messages.InvalidCreditLimit;
                }
              }
            }
          }
        }
      }
    } catch (err) {}
    return totalRows;
  };

  const addLeadingZeros = (num: any, totalLength: any) => {
    if (num == undefined) {
      num = "";
    }
    return String(num).padStart(totalLength, "0");
  };

  // Bulk Upload Functionallity
  const populateGrid = async (workbook: XLSX.WorkBook, name: any) => {
    setExcelLoder(true);
    let TempExcelSaveTradArr: any = [];
    let TempExcelSaveTradObj: any = {};
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const columns: Record<string, string> = {
      A: "b_l",
      B: "cpty_id",
      C: "tb_ticker",
      D: "cusip",
      E: "quantity",
      F: "rate",
      G: "c_n",
      H: "div",
      I: "profit_center",
      J: "term_date",
    };

    let haAnyErrorsWhileFileUpload: Boolean = false;
    if (worksheet["A1"].v === columns.A) {
      setExcelFileName(name);
      var rowIndex = 2;
      let CurrentDate = new Date();
      let CurrentDateLength = moment(CurrentDate).format("MM/DD/YYYY");

      if (worksheet["A" + rowIndex] === undefined) {
        let obj = {
          h: "",
          r: "<t>'</t>",
          t: "s",
          v: "",
          w: "",
        };
        worksheet["A" + rowIndex] = obj;
      }
      let expceFileRows: any =
        XLSX.utils.sheet_to_json(worksheet, { blankrows: false, defval: "" })
          .length + 1;
      try {
        const DatalengthArray: any = [...datalengthstate];
        let rowswithCreditLimit = await onOpenContractValueByCptyIDBulk(
          expceFileRows,
          worksheet,
          columns
        );
        let tickerList = [...tickerListContract];
        while (expceFileRows >= rowIndex) {
          const row: any = {};
          let workRowA =
            worksheet["A" + rowIndex] == undefined
              ? ""
              : worksheet["A" + rowIndex].v;
          if (workRowA !== "#") {
            Object.keys(columns).forEach(function (column) {
              row[columns[column]] = worksheet[column + rowIndex]?.w;
            });
            // clean up all inputs
            sanitizeInput(row);

            row.is_new = "TRUE";
            row.status = constants.UI_STATUS_NEW;

            row.b_l =
              row.b_l == undefined || row.b_l == null
                ? row.b_l
                : row.b_l?.toUpperCase();
            if (!(row.b_l == "B" || row.b_l == "L")) {
              row.status = constants.Error;
              row.rejected_error_reasons = messages.InvalidContract;
            }

            let contractByCusip = tickerCusipMaster.get(row.cusip);
            let contractByTicker = tickerNameMaster.get(
              row?.tb_ticker?.toUpperCase()
            );

            if (row.tb_ticker && contractByTicker) {
              row.tb_ticker = row.tb_ticker?.trim();
              row.ticker_price = contractByTicker?.price?.toFixed(2);
              row.cusip = contractByTicker?.cusip;
            } else if (row.cusip && contractByCusip) {
              row.tb_ticker = contractByCusip?.ticker;
              row.ticker_price = contractByCusip?.price.toFixed(2);
            }
            if (!row.tb_ticker) {
              row.status = constants.Error;
              row.rejected_error_reasons = messages.InvalidTicker;
            }
            let setNewQuantity: any = 0;

            if (
              row.quantity != undefined &&
              row.quantity != null &&
              row.quantity != ""
            ) {
              setNewQuantity = parseFloat(row.quantity.replaceAll(",", ""));
              row.quantity = setNewQuantity;
            }
            let cptyContract = cptyListContractMap.get(row.cpty_id);

            if (cptyContract) {
              row.cpty_name = cptyContract?.name;
              row.mark =
                row.b_l == "L"
                  ? cptyContract?.loan_mark
                  : cptyContract?.borrow_mark;
              row.cpty_id = cptyContract?.cptyId;
              row.contract_price = calculateContractPriceFromValues(
                row.ticker_price,
                row.mark,
                cptyContract
              );
              let value = row.contract_price * setNewQuantity;
              value =
                isNumber(value) && value > 0
                  ? parseFloat(value.toFixed(2))
                  : value;
              row.value = value;
            }

            if (!row.cpty_name) {
              row.status = constants.Error;
              row.rejected_error_reasons = messages.InvalidCPTY;
            }

            if (row.value == 0) {
              row.status = constants.Error;
            }

            if (row.value >= 250000000 && row.status !== constants.Error) {
              row.status = constants.UI_STATUS_WARNING;
              row.rejected_error_reasons = ">= 250M";
              row.errorCode = ">= 250M";
            }

            if (
              row.rate < -999.9999 ||
              row.rate > 999.9999 ||
              row.rate === undefined ||
              row.rate === ""
            ) {
              row.status = constants.Error;
              row.rejected_error_reasons = messages.InvalidRate;
            }
            if (isNaN(row.rate)) {
              row.status = constants.Error;
              row.rejected_error_reasons = messages.InvalidRate;
              row.rate = null;
            }

            if (
              !row.quantity ||
              isNaN(row.quantity) ||
              row.quantity > 999999999999 ||
              row.quantity % 1 !== 0 ||
              row.quantity <= 0
            ) {
              row.status = constants.Error;
              row.rejected_error_reasons = messages.InvalidQuantity;
            }

            row.div = validateDiv(row.div);

            if (
              row.term_date != undefined &&
              row.term_date != null &&
              row.term_date != ""
            ) {
              let tmpRowDate = moment(row.term_date);
              if (tmpRowDate.isValid()) {
                row.term_date = moment(row.term_date).format(
                  constants.Date_Format
                );
                if (!validateTermDate(tmpRowDate)) {
                  row.status = constants.Error;
                  row.rejected_error_reasons = messages.PastTermDate;
                }
              } else {
                row.status = constants.Error;
                row.rejected_error_reasons = messages.InvalidTermDate;
              }
            }

            if (
              !row.value ||
              !row.cpty_name ||
              !row.rate ||
              (row.rate && (row.rate < -999.9999 || row.rate > 999.9999))
            ) {
              row.status = constants.Error;
              if (!row.value) {
                row.rejected_error_reasons = messages.InvalidValue;
                row.status = constants.Error;
              }
            } else if (
              row.isCreditLimitExceeded &&
              row.status !== constants.Error
            ) {
              row.status = constants.UI_STATUS_WARNING;
              row.errorCode = messages.InvalidCreditLimit;
              row.rejected_error_reasons = messages.InvalidCreditLimit;
            } else if (
              row.value >= 250000000 &&
              row.quantity <= 999999999999 &&
              row.status !== constants.Error
            ) {
              row.status = constants.UI_STATUS_WARNING;
              row.rejected_error_reasons = ">= 250M";
              row.errorCode = ">= 250M";
            }

            if (row.c_n && row.c_n?.length === 1) {
              if (!/[CN]/.test(row.c_n)) {
                row.status = constants.Error;
                row.rejected_error_reasons = messages.InvalidCollatral;
              }
            } else {
              row.c_n = "C";
            }
            if (row.value > 999999999999.99) {
              row.status = constants.Error;
              row.rejected_error_reasons = messages.InvalidValue;
              row.errorCode = messages.InvalidValue;
            }

            if (
              row.profit_center?.length !== 1 ||
              !/[A-Z0-9 !@#$%&*()+=?]/gm.test(row.profit_center)
            ) {
              row.profit_center = " ";
            }
            let rowWithLimit = rowswithCreditLimit[rowIndex - 2];
            if (
              rowWithLimit != undefined &&
              rowWithLimit?.isCreditLimitExceeded != undefined
            ) {
              row.isCreditLimitExceeded = rowWithLimit.isCreditLimitExceeded;
              if (row.isCreditLimitExceeded && row.status !== constants.Error) {
                row.status = constants.UI_STATUS_WARNING;
                row.errorCode = messages.InvalidCreditLimit;
                row.rejected_error_reasons = messages.InvalidCreditLimit;
              }
            }
            TempExcelSaveTradObj = {
              book: "",
              sm_id: 0,
              sec_id: row.cusip,
              sec_id_type: "1",
              cpty_id: addLeadingZeros(row.cpty_id, 4),
              ccy: " ",
              bl: row.b_l == undefined ? row.b_l : row.b_l.toUpperCase(),
              status: row.status,
              quantity: setNewQuantity,
              colvalue: row.value,
              mktval: row.value,
              mkt_price: row.ticker_price,
              div: validateDiv(row.div),
              rate: row.rate,
              profit_center: row.profit_center,
              smnt_date: new Date(),
              term_date: row.term_date,
              contract_id: "",
              ext_ref_id: "",
              coll_type:
                row.c_n === "" || row.c_n === undefined ? "C" : row.c_n,
              coll_mgn: 0,
              coll_exp: 0,
              income: 0,
              finance: 0,
              date: new Date(),
              updatetime: new Date(),
              correlation_id: "",
              contract_status: constants.UI_STATUS_NEW,
              rejected_error_reasons: row.rejected_error_reasons,
              errorCode: "",
              trader: user.userName,
              trader_session: "",
              ui_status: row.status,
              ticker: row.tb_ticker ? row.tb_ticker?.toUpperCase() : "",
              cpty_name: row.cpty_name,
              contract_price: row.contract_price,
              mark: row.mark,
              rowIndex: rowIndex, //TOFIX: this is to hold the failed row numbers
            };
            TempExcelSaveTradArr.push(TempExcelSaveTradObj);
            row.dataLength = rowIndex;
            const objDatalength: any = { rowIndex: row.dataLength };
            DatalengthArray.push(objDatalength);
            setDatalengthstate(DatalengthArray);
          }

          rowIndex++;
        }
        if (haAnyErrorsWhileFileUpload) {
          setShowInvalidFilePopUp(true);
        }
        onSaveTradeStateList(TempExcelSaveTradArr);
        setExcelLoder(false);
      } catch (error) {
        setExcelLoder(false);
        console.log("error", error);
      }
    } else {
      swal({
        title: constants.Error,
        text: messages.TemplateMessage,
        icon: constants.Error,
        dangerMode: true,
        closeOnClickOutside: false,
      });
      setExcelLoder(false);
      setIsBulkUploadRunning(false);
    }
  };

  const onClickExcelDataPopNo = () => {
    setExcelDataPopOpen(false);
    // setExcelDataPopYesNo(false);
  };
  const onClickExcelBookDataPopNo = () => {
    setExcelDataBookPopOpen(false);
  };
  const onClickExcelDataClearPopNo = () => {
    setExcelDataClearPopOpen(false);
  };

  const handleSubmitContract = async () => {
    let disableBooking: boolean = false;

    const excelRowDataArray: any = [];
    // turnig the flag true, which mean the process has begun
    setIsBulkSubmitRunning(true);
    let objExcelDataforBookContract: any = {};
    let isAnyBookedItemSelected = false;
    totalSelectedRows.map((item: any) => {
      let updatedItem = rowData.find((r: any) => r.uiTradeId == item.uiTradeId);
      if (item.status !== updatedItem.status) {
        item.status = updatedItem.status;
      }
      if (item?.status !== constants.UI_STATUS_BOOKED) {
        if (
          item.status === constants.UI_STATUS_NEW ||
          item.status === constants.UI_STATUS_WARNING
        ) {
          if (!/[A-Z0-9 !@#$%&*() +=?]/.test(item.profit_center.toUpperCase)) {
            item.profit_center = "";
          }
          objExcelDataforBookContract = {
            collatoral_code: "C",
            collatoral_type: "",
            country: "",
            cpty: item.cpty_id !== "" ? item.cpty_id : "",
            currency: "",
            div: validateDiv(item.div),
            external_contract_id: "T",
            external_source: "",
            loan_value: item.value !== "" ? item.value : "",
            mark: item.mark !== "" ? item.mark : "",
            profit_center: item.profit_center,
            quantity: item.quantity !== "" ? "" + item.quantity + "" : "",
            rate: item.rate !== "" ? "" + item.rate + "" : "",
            symbol: item.tb_ticker !== "" ? item.tb_ticker : "",
            term_date: item.term_date !== "" ? item.term_date : "",
            ticker: item.tb_ticker !== "" ? item.tb_ticker : "",
            type: item.b_l !== "" ? item.b_l : "",
            tickerCusip: item.cusip !== "" ? item.cusip : "",
            cpty_name: item.cpty_name !== "" ? item.cpty_name : "",
            mkt_price: item.ticker_price !== "" ? item.ticker_price : "",
            trader: user.userName,
            uiTradeId: item.uiTradeId !== "" ? item.uiTradeId : "",
            c_n: item.c_n,
            contract_price: item.contract_price,
          };
          excelRowDataArray.push(objExcelDataforBookContract);
        } else {
          disableBooking = true;
        }
      } else {
        isAnyBookedItemSelected = true;
      }
    });

    if (disableBooking || isAnyBookedItemSelected) {
      setExcelDataBookPopOpen(true);
    } else {
      await onbookContract(excelRowDataArray);
    }
    // turnig the flag false, it will represent that the process has ended
    setIsBulkSubmitRunning(false);
    setDisabled(false);
  };

  const getData = (updated_Data: any, changeValue: any, column: Column) => {
    if (changeValue && _.isString(changeValue)) {
      changeValue = changeValue.toUpperCase();
    }
    let updateDataObj: any = {};
    let updateDataArr: any = [];

    updated_Data.status = constants.UI_STATUS_NEW;
    updated_Data.errorCode = "";

    let isValidTickerName = false;
    let isValidCusip = false;
    let isValidCpty = false;

    if (
      isString(updated_Data?.quantity) &&
      updated_Data?.quantity?.includes(",")
    ) {
      updated_Data.quantity = updated_Data?.quantity?.replace(/,/g, "");
    }
    
    //allow numeric quantity only
    if (!/^\d+(\.\d+)?$/.test(updated_Data.quantity) ||
    updated_Data.quantity === "0" || isNaN(updated_Data.quantity)) {
      updated_Data.quantity = 0;
      updated_Data.status = constants.Error;
      updated_Data.errorCode = messages.InvalidQuantity;
    }

    if (!/^\d+(\.\d+)?$/.test(updated_Data.div)) {
      updated_Data.div = 0;
    }

    

    //allow numeric rate only
    // if (!/[\d+]/.test(updated_Data.rate)) {
    //   updated_Data.rate = "";
    // }

    if (
      isNaN(updated_Data.quantity) ||
      updated_Data.quantity > 999999999999 ||
      updated_Data.quantity <= 0 ||
      updated_Data?.quantity % 1 !== 0
    ) {
      updated_Data.status = constants.Error;
      updated_Data.errorCode = messages.InvalidQuantity;
    }
    if (
      !_.isString(updated_Data?.cpty_name) ||
      !(updated_Data?.cpty_name?.length > 0)
    ) {
      updated_Data.errorCode = messages.InvalidCPTY;
      updated_Data.status = constants.Error;
      updated_Data.mark = "";
      updated_Data.cpty_name = "";
      updated_Data.value = "";
    }
    // changed Ticker or CUSIP

    let tickerByName = tickerNameMaster.get(changeValue);
    let tickerByCusip = tickerCusipMaster.get(changeValue);

    if (column.getColId() === "tb_ticker") {
      if (tickerByName) {
        updated_Data.cusip = tickerByName?.cusip;
        updated_Data.ticker_price = tickerByName?.price;
        isValidTickerName = true;
      }
    } else if (column.getColId() === "cusip") {
      if (tickerByCusip) {
        updated_Data.tb_ticker = tickerByCusip?.ticker;
        updated_Data.ticker_price = tickerByCusip?.price;
        isValidCusip = true;
        isValidTickerName = true;
      }
    }

    if (!isValidTickerName && column.getColId() === "tb_ticker") {
      updated_Data.errorCode = messages.InvalidTicker;
      applyInvalidTickerProps(updated_Data);
    }
    if (!isValidCusip && column.getColId() === "cusip") {
      updated_Data.errorCode = messages.InvalidCPTY;
      updated_Data.tb_ticker = "";
      applyInvalidTickerProps(updated_Data);
    }

    if (!updated_Data.tb_ticker) {
      updated_Data.errorCode = messages.InvalidTicker;
      updated_Data.status = constants.Error;
    }

    if (
      !updated_Data.cpty_id ||
      !updated_Data.tb_ticker ||
      isNaN(updated_Data.quantity) ||
      !updated_Data.quantity
    ) {
      updated_Data.status = constants.Error;
    }

    if (column.getColId() === "cpty_id") {
      let counterPartyContract = cptyListContractMap.get(changeValue);
      if (counterPartyContract) {
        updated_Data.cpty_id = changeValue;
        updated_Data.cpty_name = counterPartyContract.name;
        if (updated_Data.b_l == "B" || updated_Data.b_l == "b") {
          updated_Data.mark = counterPartyContract.borrow_mark;
        } else if (updated_Data.b_l == "l" || updated_Data.b_l == "L") {
          updated_Data.mark = counterPartyContract.loan_mark;
        }
        isValidCpty = true;
      }
    } else if (
      column.getColId() === "b_l" &&
      updated_Data.cpty_id &&
      updated_Data.cpty_id?.length > 0
    ) {
      let cptyContract = cptyListContractMap.get(updated_Data.cpty_id);
      if (cptyContract) {
        if (updated_Data.b_l === "B" || updated_Data.b_l === "b") {
          updated_Data.mark = cptyContract?.borrow_mark;
        } else if (updated_Data.b_l === "l" || updated_Data.b_l === "L") {
          updated_Data.mark = cptyContract?.loan_mark;
        }
      }
    }

    if (
      isValidCpty &&
      updated_Data.errorCode === messages.InvalidCPTY &&
      _.isString(updated_Data?.cpty_name) &&
      updated_Data?.cpty_name?.length > 0
    ) {
      updated_Data.errorCode = "";
      updated_Data.status = constants.UI_STATUS_NEW;
    }

    // changed Quantity
    let counterPartyContract = cptyListContractMap.get(updated_Data.cpty_id);

    if (counterPartyContract) {
      let cPrice = calculateContractPriceFromValues(
        updated_Data.ticker_price,
        updated_Data.mark,
        counterPartyContract
      );
      
      let value = isNaN(updated_Data.quantity) || _.isUndefined(cPrice)
        ? null
        : (updated_Data.value = cPrice * updated_Data.quantity);
      value =
                isNumber(value) && value > 0
                  ? parseFloat(value.toFixed(2))
                  : value;
      updated_Data.value = value;
      updated_Data.contract_price = cPrice;
    }

    validateCusipNTickerNCptyName(updated_Data);

    // changed Rate

    if (!validateRate(updated_Data.rate)) {
      updated_Data.status = constants.Error;
      updated_Data.errorCode = messages.InvalidRate;
    }

    if (isNaN(updated_Data.rate)) {
      updated_Data.status = constants.Error;
      updated_Data.errorCode = messages.InvalidRate;
      updated_Data.rate = null;
    }

    if (!isValidCpty && column.getColId() === "cpty_id") {
      updated_Data.errorCode = messages.InvalidCPTY;
      updated_Data.status = constants.Error;
      updated_Data.mark = "";
      updated_Data.cpty_name = "";
      updated_Data.value = "";
    }
    //  Validate cusip , tb_ticker, cpty_name
    validateCusipNTickerNCptyName(updated_Data);
    if (
      updated_Data.value >= 250000000 &&
      updated_Data.status !== constants.Error
    ) {
      updated_Data.status = constants.UI_STATUS_WARNING;
      updated_Data.rejected_error_reasons = ">= 250M";
      updated_Data.errorCode = ">= 250M";
    }
    if (updated_Data.value < 0 || updated_Data.value > 999999999999.99) {
      updated_Data.status = constants.Error;
      updated_Data.errorCode = messages.InvalidContractValue;
    }

    let todayDate = moment();

    if (
      _.isString(updated_Data.term_date) &&
      updated_Data?.term_date?.length > 0
    ) {
      updated_Data.term_date = updated_Data.term_date?.trim();
    }
    if (
      updated_Data.term_date !== undefined &&
      updated_Data.term_date !== null &&
      updated_Data.term_date !== ""
    ) {
      let tmpRowDate = moment(updated_Data.term_date);
      // const regexobj = /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/;
      // const validobj = regexobj.test(updated_Data.term_date);
      if (tmpRowDate.isValid()) {
        updated_Data.term_date = moment(updated_Data.term_date).format(
          constants.Date_Format
        );
        if (!validateTermDate(tmpRowDate)) {
          updated_Data.status = constants.Error;
          updated_Data.errorCode = messages.PastTermDate;
        }
      } else {
        updated_Data.status = constants.Error;
        updated_Data.errorCode = messages.InvalidTermDate;
      }
    }

    // changed B_L
    updated_Data.b_l =
      updated_Data.b_l == undefined || updated_Data.b_l == null
        ? ""
        : updated_Data.b_l.toUpperCase();

    if (
      updated_Data.b_l != undefined &&
      !(updated_Data.b_l == "B" || updated_Data.b_l == "L")
    ) {
      updated_Data.status = constants.Error;
      updated_Data.errorCode = messages.InvalidContract;
      updated_Data.mark = "";
    }

    updated_Data.c_n = trimValue(updated_Data.c_n);
    if (updated_Data.c_n?.length !== 1 || !/[CN]/.test(updated_Data.c_n)) {
      updated_Data.c_n = "C";
    }

    if (
      !updated_Data.div ||
      updated_Data.div < 0 ||
      updated_Data.div > 999 ||
      isNaN(updated_Data.div)
    ) {
      updated_Data.div = 100;
    }

    if (updated_Data.profit_center === null) {
      updated_Data.profit_center = "";
    }

    if (
      updated_Data.profit_center?.length !== 1 ||
      !/[A-Z0-9a-z !@#$%&*()+=?]/gm.test(updated_Data.profit_center)
    ) {
      updated_Data.profit_center = " ";
    }
    if (/[A-Za-z]/gm.test(updated_Data.profit_center)) {
      updated_Data.profit_center = updated_Data.profit_center.toUpperCase();
    }
    let ticker = tickerNameMaster.get(updated_Data?.tb_ticker?.toUpperCase());
    if (!isValidTickerName && !ticker) {
      updated_Data.errorCode = messages.InvalidTicker;
      updated_Data.status = constants.Error;
    }
    if (
      _.isUndefined(updated_Data.mark) ||
      (_.isString(updated_Data.mark) && _.isEmpty(updated_Data.mark))
    ) {
      updated_Data.mark = null;
    }

    if (
      !/[\d+]/.test(updated_Data.quantity) ||
      updated_Data.quantity === "0" ||
      updated_Data.quantity === 0 ||
      isNaN(updated_Data.quantity)
    ) {
      updated_Data.quantity = 0;
      updated_Data.status = constants.Error;
      updated_Data.errorCode = messages.InvalidQuantity;
    }

    updateDataObj = {
      ui_trade_id: updated_Data.uiTradeId,
      book: "",
      sm_id: 0,
      sec_id: updated_Data.cusip,
      sec_id_type: 1,
      cpty_id: updated_Data.cpty_id,
      ccy: "",
      bl: updated_Data.b_l,
      status: updated_Data.status,
      quantity: updated_Data.quantity,
      colvalue: updated_Data.value,
      mktval: updated_Data.value,
      div: validateDiv(updated_Data.div),
      rate: updated_Data.rate,
      profit_center: updated_Data.profit_center,
      smnt_date: new Date(),
      term_date: updated_Data.term_date,
      contract_id: "",
      ext_ref_id: "",
      coll_type: updated_Data.c_n,
      coll_mgn: 0,
      coll_exp: 0,
      income: 0,
      finance: 0,
      date: new Date(),
      updatetime: new Date(),

      correlation_id: "",
      contract_status: updated_Data.status,
      rejected_error_reasons: updated_Data.errorCode,
      trader: user.userName,
      trader_session: "",
      ui_status: updated_Data.status,
      ticker: updated_Data.tb_ticker?.toUpperCase(),
      cpty_name: updated_Data.cpty_name,
      mark: updated_Data.mark,
      mkt_price: updated_Data.mkt_price,
      contract_price: updated_Data.contract_price,
      errorCode:
        updated_Data.status === constants.UI_STATUS_NEW
          ? ""
          : updated_Data.errorCode,
    };
    let list: any[] = [];
    let cptyId =
      updated_Data?.cpty_id &&
      updated_Data.cpty_id?.length >= 1 &&
      updated_Data.cpty_id?.length < 4
        ? updated_Data.cpty_id?.padStart(4, "0")
        : updated_Data?.cpty_id;
    cptyId = cptyId && cptyId?.length > 0 ? cptyId?.toUpperCase() : cptyId;
    if (
      updated_Data.cpty_id &&
      updated_Data.b_l &&
      (updated_Data.b_l?.toLowerCase() === "b" ||
        updated_Data.b_l?.toLowerCase() === "l")
    ) {
      list = [
        {
          bl: updated_Data.b_l,
          cpty_id: updated_Data.cpty_id,
        },
      ];
    }
    if (list && list?.length > 0) {
      creditLimitExceedCheck(list, updated_Data)
        .then((isCreditLimitExceeded: boolean) => {
          if (
            _.isBoolean(isCreditLimitExceeded) &&
            isCreditLimitExceeded &&
            updated_Data?.status !== constants?.Error
          ) {
            updateDataObj.isCreditLimitExceeded = true;
            updateDataObj.errorCode = messages.InvalidCreditLimit;
            updateDataObj.rejected_error_reasons = messages.InvalidCreditLimit;
            updateDataObj.ui_status = constants.UI_STATUS_WARNING;
          }
        })
        .finally(() => {
          if (updateDataObj?.ui_status !== constants.Error) {
            updateDataArr.push(updateDataObj);
            onUpdateTradeState(updateDataArr, updateDataObj);
          }
        });
    } else {
      if (updateDataObj?.ui_status !== constants.Error) {
        updateDataArr.push(updateDataObj);
        onUpdateTradeState(updateDataArr, updateDataObj);
      }
    }
  };

  const onUpdateTradeState = async (Data: any, trade: any) => {
    var accessToken = window.localStorage.getItem("refreshtoken");
    let updateTradeStateRes: any = await updateTradeState(
      Data,
      user.tokenType,
      accessToken
    );
    if (!updateTradeStateRes) {
      swal({
        title: constants.Error,
        text: messages.tradeManagementMessage,
        icon: constants.swalIconError,
        dangerMode: true,
        closeOnClickOutside: false,
      });
    }
    if (updateTradeStateRes?.status === 401) {
      navigate("/signin");
    } else {
      setRowData((previousRows: any) => {
        let currentRows = [...previousRows];
        let index = currentRows?.findIndex(
          (t) => t.uiTradeId === trade?.uiTradeId
        );
        if (index >= 0) {
          currentRows[index] = trade;
        }
        return currentRows;
      });
    }
  };

  const creditLimitExceedCheck = async (cptyBLList: any, trade: any) => {
    var accessToken = window.localStorage.getItem("refreshtoken");
    let getOpenContractValueByCptyIDRes = await getOpenContractValueByCptyID(
      cptyBLList,
      user.tokenType,
      accessToken
    );
    if (!getOpenContractValueByCptyIDRes) {
      setOpen(true);
      setSnackbarMessage(messages.contractBookMessage);
    } else if (getOpenContractValueByCptyIDRes.status === 200) {
      let getOpenContractValueByCptyIDData =
        await getOpenContractValueByCptyIDRes.json();
      let contractList = JSON.parse(JSON.stringify(cptyListContract));
      let tickerList = JSON.parse(JSON.stringify(tickerListContract));
      if (
        getOpenContractValueByCptyIDData?.result != null &&
        getOpenContractValueByCptyIDData?.result != undefined &&
        getOpenContractValueByCptyIDData?.result.length > 0 &&
        trade &&
        trade?.cpty_id != undefined &&
        trade?.cpty_id != 0 &&
        trade?.cpty_id != null
      ) {
        for (
          let index = 0;
          index < getOpenContractValueByCptyIDData?.result?.length;
          index++
        ) {
          if (
            getOpenContractValueByCptyIDData?.result[index]?.error === "Success"
          ) {
            trade.isCreditLimitExceeded = false;
            let cptyId =
              trade.cpty_id &&
              trade.cpty_id?.length >= 1 &&
              trade.cpty_id?.length < 4
                ? trade?.cpty_id?.padStart(4, "0")
                : trade.cpty_id;
            cptyId =
              cptyId && cptyId?.length > 0 ? cptyId?.toUpperCase() : cptyId;
            let openContract = getOpenContractValueByCptyIDData?.result?.find(
              (c: any) => c.cpty_id === cptyId
            );
            // let cptyContract = contractList?.find(
            //   (c: any) => (c.cptyId === cptyId)
            // );

            let cptyContract = cptyListContractMap?.get(cptyId);
            // let tickerContract = tickerList?.find(
            //   (t: any) =>
            //     t.cusip === trade.cusip ||
            //     t.ticker?.toUpperCase() === trade?.tb_ticker?.toUpperCase()
            // );
            let tickerContract = tickerNameMaster?.get(
              trade?.tb_ticker?.toUpperCase()
            );
            if (
              openContract != undefined &&
              cptyContract != undefined &&
              tickerContract != undefined
            ) {
              let tickerPrice = tickerContract?.price?.toFixed(2);
              let mark =
                trade.b_l == "L"
                  ? cptyContract.loan_mark
                  : cptyContract.borrow_mark;

              const outstandingValue = openContract?.total_col_value;
              let contract_price = calculateContractPriceFromValues(
                tickerPrice,
                mark,
                cptyContract
              );
              const newValue = trade?.value + outstandingValue;
              let quantity: any = 0;
              if (
                trade.quantity != undefined &&
                trade.quantity != null &&
                trade.quantity != ""
              ) {
                quantity = isString(trade?.quantity)
                  ? parseFloat(trade?.quantity?.replaceAll(",", ""))
                  : trade.quantity;
              }
              let value = contract_price * quantity;
              if (openContract.bl === "B") {
                if (
                  newValue > cptyContract?.borr_acct_limit &&
                  trade.status !== constants.Error
                ) {
                  trade.isCreditLimitExceeded = true;
                  trade.errorCode = messages.InvalidCreditLimit;
                  trade.rejected_error_reasons = messages.InvalidCreditLimit;
                  trade.status = constants.UI_STATUS_WARNING;
                }
              } else if (openContract.bl === "L") {
                if (
                  newValue > cptyContract?.loan_acct_limit &&
                  trade.status !== constants.Error
                ) {
                  trade.isCreditLimitExceeded = true;
                  trade.errorCode = messages.InvalidCreditLimit;
                  trade.rejected_error_reasons = messages.InvalidCreditLimit;
                  trade.status = constants.UI_STATUS_WARNING;
                }
              }
            }

            return trade.isCreditLimitExceeded;
          }
        }
      }
    }
  };

  const markFieldRef = useRef<any>(null);
  const quantitywarningYes = () => {
    setInvalidQuantity(false);
    setTimeout(() => {
      markFieldRef.current.focus();
    }, 500);
  };
  const quantitywarningNo = () => {
    setInvalidQuantity(false);
  };
  const handleMinimizeContract = () => {
    if (minimizeContract === true) {
      setMinimizeContract(false);
    } else if (minimizeContract === false) {
      setMinimizeContract(true);
    }
  };

  useEffect(() => {
    handleHeight();
  }, [minimizeContract, checkedRadioContract, minimizeTrade]);

  const handleMinimizeSubheader = () => {
    if (minimizeTrade === true) {
      setMinimizeTrade(false);
      return false;
    } else if (minimizeTrade === false) {
      setMinimizeTrade(true);
      return true;
    }
  };
  const submitHeader = () => {
    setSubmitheader(true);
  };
  const { height: windowHeight, width: windowWidth } = useWindowDimensions();
  const handleHeight = () => {
    let subHeader = document.getElementsByClassName("subHeaderContract");
    let headerHeight = subHeader[0].clientHeight;
    let screenHeight = windowHeight+25; //window.innerHeight;
    headerHeight += 79 + 64;
    let gridHeight = screenHeight - headerHeight -30;
    let agGridInner = document.querySelector<HTMLElement>(".ag-theme-balham");
    let agGrid: any = document.querySelector("#agBlukTradeEntry");
    if (agGrid !== null && agGrid !== undefined)
      agGrid.style.height = gridHeight + "px";
    if (agGridInner !== null && agGridInner !== undefined)
      agGridInner.style.height = gridHeight + "px";
  };
  useEffect(handleHeight, [windowHeight]);

  // Should a full screen loader be shown on the Screen
  const doShowFullScreenLoader: boolean =
    isBulkUploadRunning || isBulkSubmitRunning || showClearLoader || isLoading;
  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === constants.clickaway) {
      return;
    }

    setOpen(false);
  };

  const onBulkTradeSubmit = () => {
    if (totalSelectedRows?.length > 0) {
      setDisabled(false);
      handleSubmitContract();
      setisNoRecordsSelectedWarning(false);
      setIsDeselectAll(!isDeselectAll);
    } else {
      setisNoRecordsSelectedWarning(true);
    }
  };

   useEffect(()=>{
      setTimeout(() => {
            queue?.dequeue()
          }, 1500);
  },[rowData])

  return (
    <>
      {doShowFullScreenLoader && <SpinnerFullScreen></SpinnerFullScreen>}
      <Snackbar open={open} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="error"
          sx={{
            width: "100%",
            backgroundColor: "orange",
            textDecorationColor: "white",
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <div
        style={{
          height: "90%",
          backgroundColor: "#EAECEF",
        }}
      >
        <div className="subHeaderContract mt-1" style={{marginBottom:'0.8rem'}} id='sub-header'>
          <SubHeader
            title="Single Trade Entry"
            setMarkFieldisMatchEvent={setMarkFieldisMatchEvent}
            setMarkFieldEvent={setMarkFieldEvent}
            submitContract={onSubmit}
            handleMinimize={handleMinimizeSubheader}
            needToClearForm={needToClearForm}
            handlesubmitheader={submitHeader}
            checkRadioProp={(event: any) => {
              setCheckRadioContract(event.target.checked);
            }}
            borrowAndLoneFieldprop={(e: any) => {
              setTradeType(e);
            }}
            borrowAndLoneFieldLengthprop={(borrowAndLoanField: any) => {
              setBorrowAndLoanFieldLength(borrowAndLoanField);
            }}
            counterPartyFieldprop={(value: any) => {
              setCounterPartyinContract(value.name);
              setMarkFieldContract(value.cptyId);
              setMarkAllValue(value);
            }}
            TickerFieldprop={(value: any) => {
              setTickerContract(value.ticker);
              setTickerPrice(value.price);
              setTickerCusip(value.cusip);
            }}
            QuantityFieldprop={(e: any) => {
              setQuantityContract(e.target.value);
            }}
            RateFieldprop={(e: any) => {
              setRateFieldContract(e.target.value);
            }}
            MarkFieldprop={(value: any) => {
              setMarkField(value);
            }}
            MarkFieldEventprop={(e: any) => {
              setMarkFieldEvent(e.target.value);
            }}
            ContractValueFieldprop={(e: any) => {
              setContractValueContract(e);
            }}
            ContractValueFieldEventprop={(e: any) => {
              setContractValueEventContract(e);
            }}
            contractPriceprop={(value: any) => {
              setContractPriceContract(value);
            }}
            ProfitCenterFieldprop={(e: any) => {
              setProfitCenterFieldContract(e.target.value.toUpperCase());
            }}
            divTextFieldprop={(e: any) => {
              setDivTextFieldContract(e.target.value);
            }}
            TermDateFieldprop={(value: any) => {
              setTermDateFieldContract(moment(value).format("MM/DD/YYYY"));
            }}
            cashNonCashprop={(e: any) => {
              setCashNonCashContract(e.target.value.toUpperCase());
            }}
            borrowAndLoneFieldisMatchprop={(e: any) => {
              setBaLinContractisMatch(e.target.value);
            }}
            CounterPartyClick={(item: any) => {
              setCounterPartySearch(item.NAME);
            }}
            CounterPartyClickisMatch={(item: any) => {
              setCounterPartySearchisMatch(item.NAME);
            }}
            TickerSearch={(item: any) => {
              setTickerSearch(item.Ticker);
            }}
            TickerSearchMatch={(item: any) => {
              setTickerSearchisMatch(item.Ticker);
            }}
            counterPartyFieldisMatchprop={(value: any) => {
              setCounterPartyinContractisMatch(value.name);
              setMarkFieldContractisMatch(value.cptyId);
            }}
            TickerFieldisMatchprop={(e: any) => {
              setTickerContractisMatch(e.target.value);
            }}
            QuantityFieldisMatchprop={(e: any) => {
              setQuantityContractisMatch(e.target.value);
            }}
            RateFieldisMatchprop={(e: any) => {
              setRateFieldContractisMatch(e.target.value);
            }}
            MarkFieldisMatchprop={(value: any) => {
              // setMarkFieldContractisMatch(e);
              setMarkFieldisMatch(value);
            }}
            MarkFieldisMatchEventprop={(e: any) => {
              setMarkFieldisMatchEvent(e.target.value);
            }}
            ContractValueFieldisMatchprop={(e: any) => {
              setContractValueContractisMatch(e);
            }}
            ContractValueFieldisMatchEventprop={(e: any) => {
              setContractValueContractEventisMatch(e);
            }}
            contractPriceisMatchprop={(value: any) => {
              setContractPriceContractisMatch(value);
            }}
            ProfitCenterFieldisMatchprop={(e: any) => {
              setProfitCenterFieldContractisMatch(e.target.value.toUpperCase());
            }}
            divTextFieldisMatchprop={(e: any) => {
              setDivTextFieldContractisMatch(e.target.value);
            }}
            TermDateFieldisMatchprop={(value: any) => {
              setTermDateFieldContract(moment(value).format("MM/DD/YYYY"));
            }}
            cashNonCashMatchprop={(e: any) => {
              setCashNonCashMatchContract(e.target.value.toUpperCase());
            }}
            cptyListProp={(value: any) => {
              setCptyListContract(value);
              setCptyListContractMap(
                new Map(value.map((c: any) => [c.cptyId, c]))
              );
            }}
            tickerListProp={(value: any) => {
              setTickerListContract(value);
              setTickerNameMaster(() => {
                return new Map(value.map((c: any) => [c.ticker, c]));
              });
            }}
            isSubmitDisabledToggle={isSubmitDisabledToggle}
            tickerCusipMap={(value: any) => {
              setTickerCusipMaster(value);
            }}
            cptyListMap={(value: any) => {}}
          />
        </div>

        <Modal
          size="lg"
          centered
          show={isNoRecordsSelectedWarning}
          onHide={() => setisNoRecordsSelectedWarning(false)}
          style={{ top: "15%", width: "20%", left: "40%" }}
          backdrop="static"
        >
          <Modal.Header
            style={{
              backgroundColor: "#6a7587",
              color: "#fff",
              height: "3rem",
            }}
          >
            <Modal.Title>Warning</Modal.Title>
          </Modal.Header>
          <Modal.Body>Please select at lease one record</Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setisNoRecordsSelectedWarning(false)}>
              Ok
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          size="lg"
          centered
          show={excelDataPopOpen}
          onHide={() => setExcelDataPopOpen(false)}
          style={{ top: "15%", width: "20%", left: "40%" }}
          backdrop="static"
        >
          <Modal.Header
            style={{
              backgroundColor: "#6a7587",
              color: "#fff",
              height: "3rem",
            }}
          >
            <Modal.Title>Warning</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            The trade entries you submitted has some errors, please correct it
            and then submit it again.
          </Modal.Body>
          <Modal.Footer>
            {/* <Button onClick={() => onClickExcelDataPopYes()}>Yes</Button> */}
            <Button onClick={() => onClickExcelDataPopNo()}>Ok</Button>
          </Modal.Footer>
        </Modal>
        <Modal
          size="lg"
          centered
          show={excelDataClearPopOpen}
          onHide={() => setExcelDataClearPopOpen(false)}
          // className="adjustModal"
          style={{ top: "15%", width: "20%", left: "40%" }}
          backdrop="static"
        >
          <Modal.Header
            style={{
              backgroundColor: "#6a7587",
              color: "#fff",
              height: "3rem",
            }}
          >
            <Modal.Title>Warning</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            You cannot remove “Sent” trades. Please unselect “Sent” trades and
            try again
          </Modal.Body>
          <Modal.Footer>
            {/* <Button onClick={() => onClickExcelDataPopYes()}>Yes</Button> */}
            <Button onClick={() => onClickExcelDataClearPopNo()}>Ok</Button>
          </Modal.Footer>
        </Modal>
        <Modal
          size="lg"
          centered
          show={excelDataBookPopOpen}
          onHide={() => setExcelDataBookPopOpen(false)}
          // className="adjustModal"
          style={{ top: "15%", width: "20%", left: "40%" }}
          backdrop="static"
        >
          <Modal.Header
            style={{
              backgroundColor: "#6a7587",
              color: "#fff",
              height: "3rem",
            }}
          >
            <Modal.Title>Warning</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Some of the trades you selected cannot be submitted
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => onClickExcelBookDataPopNo()}>Ok</Button>
          </Modal.Footer>
        </Modal>
        <Modal
          size="lg"
          centered
          show={borrowValOpen}
          onHide={() => setBorrowValOpen(false)}
          style={{ top: "15%", width: "20%", left: "40%" }}
          backdrop="static"
        >
          <Modal.Header
            style={{
              backgroundColor: "#6a7587",
              color: "#fff",
              height: "3rem",
            }}
          >
            <Modal.Title>Warning</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div>
                Borrow limit for {borrCptyIdModal} will exceed after this trade.
              </div>
              <div>This Trade: {thisContractVal}</div>
              <div>Borrow Limit: {borrAcctLimit}</div>
              <div>Open Borrow Contracts: {outstandingBorrow}</div>
              <div>Do you want to proceed booking this trade?</div>
              {/* <div> Remaining: {remainingBorrow}</div> */}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => onClickBorrowValYes()}>Yes</Button>
            <Button onClick={() => onClickBorrowValNo()}>No</Button>
          </Modal.Footer>
        </Modal>

        {/* Invalid File Entries */}
        <Modal
          size="lg"
          centered
          show={showInvalidFilePopUp}
          onHide={() => setShowInvalidFilePopUp(false)}
          // className="adjustModal"
          style={{ top: "15%", width: "20%", left: "40%" }}
          backdrop="static"
        >
          <Modal.Header
            style={{
              backgroundColor: "#6a7587",
              color: "#fff",
              height: "3rem",
            }}
          >
            <Modal.Title>Warning</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div>
                These rows were skipped:{" "}
                {invalidFileEntries.length > 0
                  ? invalidFileEntries.substring(1, invalidFileEntries.length)
                  : invalidFileEntries}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setShowInvalidFilePopUp(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Loan value */}
        <Modal
          size="lg"
          centered
          show={loanValOpen}
          onHide={() => setLoanValOpen(false)}
          // className="adjustModal"
          style={{ top: "15%", width: "20%", left: "40%" }}
          backdrop="static"
        >
          <Modal.Header
            style={{
              backgroundColor: "#6a7587",
              color: "#fff",
              height: "3rem",
            }}
          >
            <Modal.Title>Warning!</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div>
                Loan limit for {loanCptyIdModal} will exceed after this trade.
              </div>
              <div>This Trade: {thisContractVal}</div>
              <div>Loan Limit: {loanAcctLimit}</div>
              <div>Open Loan Contracts: {outstandingLoan}</div>
              <div>Do you want to proceed booking this trade?</div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => onClickLoanValYes()}>Yes</Button>
            <Button onClick={() => onClickLoanValNo()}>No</Button>
          </Modal.Footer>
        </Modal>
        <Modal
          size="sm"
          centered
          show={invalidQuantity}
          onHide={() => setInvalidQuantity(false)}
          backdrop="static"
        >
          <Modal.Header
            style={{
              backgroundColor: "#6a7587",
              color: "#fff",
              height: "3rem",
            }}
          >
            <Modal.Title>Warning</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>Invalid Quantity</div>
            <div>Quantity Can have max length of 12.</div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => quantitywarningYes()}>Yes</Button>
            <Button onClick={() => quantitywarningNo()}>No</Button>
          </Modal.Footer>
        </Modal>

        <div className="react-grid-item-contract">
          <div className="contractBooking-Button">
            <div className="title-subHeaderTitle" style={{paddingLeft:'0.5rem'}}>Bulk Trade Entry</div>
            <div className="clear-submit-btn-div">
              {minimizeContract === true && (
                <>
                  <a
                    href="/BulkTradeEntryTemplate.xlsx"
                    download
                    className="templetelink"
                  >
                    Download Blank Template
                  </a>
                  <div className="upload-btn-main-div">
                    {excelFileName === "" ? (
                      <button
                        disabled={
                          !hasAccess([
                            `${pageConstant.TRADE_BOOKING}_RW`,
                            `${pageConstant.TRADE_BOOKING}_ADMIN`,
                          ]) || isTradeServiceDown
                        }
                        className="excel-upload-btn"
                      >
                        <input
                          disabled={
                            !hasAccess([
                              `${pageConstant.TRADE_BOOKING}_RW`,
                              `${pageConstant.TRADE_BOOKING}_ADMIN`,
                            ]) || isTradeServiceDown
                          }
                          type="file"
                          className="FileUpload"
                          onChange={onChange}
                          accept=".xlsx,.xlsm,.xlsb,.xltx,.xltm,.xlt,.xls,.xls"
                          ref={ref}
                        />
                        <div className="dropZoneOverlay">
                          <AddCircleOutlineIcon
                            style={{
                              color: "#1E355E",
                              marginBottom: "0.1rem",
                              marginRight: "0.5rem",
                              height: "1.21rem",
                              width: "1.25rem",
                            }}
                          />
                          {excelLoder === true ? (
                            <div
                              className="spinner-border text-dark spinner-border-sm"
                              role="status"
                            ></div>
                          ) : (
                            "Upload Excel File"
                          )}
                        </div>
                      </button>
                    ) : (
                      <div className="file-name me-3">
                        {excelFileName}
                        {excelFileName === "" ? (
                          ""
                        ) : (
                          <CancelIcon
                            onClick={onClear}
                            style={{
                              color: "#E90909",
                              height: "0.9rem",
                              cursor: "pointer",
                            }}
                          />
                        )}
                      </div>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary uploadSheet-submit-Btn"
                    disabled={
                      !hasAccess([
                        `${pageConstant.TRADE_BOOKING}_RW`,
                        `${pageConstant.TRADE_BOOKING}_ADMIN`,
                      ]) ||
                      totalSelectedRows?.length === 0 ||
                      disabled
                    }
                    onClick={() => {
                      onBulkTradeSubmit();
                    }}
                    title="You can only submit  “New” trades. Please select “New” trades and try again"
                  >
                    Submit
                  </button>
                  <button
                    className={
                      disableClearBtn === true ||
                      totalSelectedRows?.length === 0
                        ? "clearAll-BtnDisable"
                        : "clearAll-Btn"
                    }
                    onClick={onClearAll}
                    disabled={totalSelectedRows?.length === 0}
                    title="You cannot remove “Sent” trades. Please unselect “Sent” trades and try again"
                  >
                    Clear
                  </button>

                  <span
                    className="borrowExceldnld float-start"
                    onClick={() => refData?.current?.api?.exportDataAsExcel()}
                    title="Download Excel"
                  >
                    <img
                      src={excel}
                      alt=""
                      style={{
                        height: "1.8rem",
                        width: "1.8rem",
                        cursor: "pointer",
                      }}
                    />
                  </span>
                  <div className="refreshiconContract" title="Refresh Data">
                    <RefreshIcon
                      onClick={() => {
                        refreshGrid(true);
                      }}
                      style={{
                        color: "#1E355E",
                        marginRight: "0.5rem",
                        height: "1.6rem",
                        width: "1.6rem",
                        cursor: "pointer",
                      }}
                    />
                    <div className="refreshsettimedateContract">
                      <div>Last updatede on: </div>
                      <div>{refresh}</div>
                    </div>
                  </div>
                </>
              )}
              <div
                className={
                  minimizeContract === true
                    ? constants.minIconContract
                    : constants.minIconContractfalse
                }
                onClick={() => handleMinimizeContract()}
              >
                {minimizeContract === false ? (
                  <KeyboardArrowDownIcon />
                ) : (
                  <KeyboardArrowUpIcon />
                )}
              </div>
            </div>
          </div>
          {minimizeContract === true && (
            <div id="agBlukTradeEntry" style={{ marginBottom: "3rem" }}>
              {gridLoder === true ? (
                <div
                  className="spinner-border text-dark spinner-border-lg "
                  role="status"
                ></div>
              ) : null}

              <ContractGrid
                isDeselectAll={isDeselectAll}
                rowData={rowData}
                height={heightAG_1}
                seTtotalSelectedRows={seTtotalSelectedRows}
                getBtnRef={(gridRef: any) => {
                  setRefData(gridRef);
                }}
                onCellChange={(data: any, value: any, column: Column) => {
                  getData(data, value, column);
                }}
                onClickHan={(data: any) => {
                  setSelectedRows(data);
                }}
                onClickSelectData={(data: any) => {
                  setSelectedRowsBookContract(data);
                }}
              />
            </div>
          )}
       </div>
      </div>
    </>
  );
};

export default withTicker(withCpty(withRefresh(withUser(Contract))));

function sanitizeInput(row: any) {
  row.b_l = trimValue(row.b_l);
  row.tb_ticker = trimValue(row.tb_ticker);
  row.cpty_id = trimValue(row.cpty_id);
  row.rate = trimValue(row.rate);
  row.div = trimValue(row.div);
  row.termDate = trimValue(row.termDate);
  //row.quantity = (isNaN(row.quantity)) ? 0 : row.quantity;

  // fix cusip
  row.cusip = trimValue(row.cusip);
  if (row.cusip) {
    if (row.cusip.length === 8) {
      row.cusip = "0" + row.cusip;
    }
  }

  // fix cpty_id
  row.cpty_id = trimValue(row.cpty_id);
  if (row.cpty_id && row.cpty_id.length < 4) {
    row.cpty_id = String(row.cpty_id).padStart(4, "0");
  }

  // fix profit center
  row.profit_center = trimValue(row.profit_center);
  if (!/[A-Z0-9 !@#$%&*()+=?]/.test(row.profit_center)) {
    row.profit_center = "";
  }

  row.c_n = trimValue(row.c_n);
  if (!/[CN]/.test(row.c_n)) {
    row.c_n = "C";
  }
}

function trimValue(value: any) {
  if (value) {
    value = value.trim().toUpperCase();
  }
  return value;
}

function getErrorCodeFromItem(item: any) {
  if (
    item &&
    item.rejected_error_reasons &&
    !item.rejected_error_reasons.includes("Contract added", 0)
  ) {
    return item.rejected_error_reasons;
  }
  return "";
}

function validateDiv(divValue: any) {
  let div = parseInt(divValue);
  if (div && div <= 100 && div > 0) {
    return div;
  }
  return 100;
}

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));
